
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("cKcai", function(module, exports) {

$parcel$export(module.exports, "WelcomeModalRenderer", () => $7e09df05ad2a703b$export$5d9e1395db999a45);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $6BT89 = parcelRequire("6BT89");

var $aTWms = parcelRequire("aTWms");


var $83g2V = parcelRequire("83g2V");
const $7e09df05ad2a703b$var$WelcomeModalRendererInner = ()=>{
    const { isWelcomeModalActivated: isWelcomeModalActivated, finalWelcomeModalIsOpen: finalWelcomeModalIsOpen, handleCloseWelcomeModal: handleCloseWelcomeModal } = (0, $6BT89.useGlobalChangeboarding)();
    if (!isWelcomeModalActivated) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $83g2V.Wizard), {
        isOpen: Boolean(finalWelcomeModalIsOpen),
        onClose: handleCloseWelcomeModal,
        defaultStep: (0, $8bd01cb292c29cb9$export$75f90732d1326d15)
    });
};
const $7e09df05ad2a703b$export$5d9e1395db999a45 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        teamName: "alexstrasza",
        packageName: "jiraEocChangeboarding",
        id: "jiraEocChangeboarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aTWms.ChangeboardingProviders), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e09df05ad2a703b$var$WelcomeModalRendererInner, null)));

});
parcelRegister("6BT89", function(module, exports) {

$parcel$export(module.exports, "useGlobalChangeboarding", () => $190423316351a626$export$e618620d6c810888);

var $5uXOq = parcelRequire("5uXOq");

var $8J6rn = parcelRequire("8J6rn");

var $pa9q9 = parcelRequire("pa9q9");

var $7jF6i = parcelRequire("7jF6i");


var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $9OXo1 = parcelRequire("9OXo1");

var $ieDtd = parcelRequire("ieDtd");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4iQaI = parcelRequire("4iQaI");

var $lLiTq = parcelRequire("lLiTq");

var $luBum = parcelRequire("luBum");

var $5fIfP = parcelRequire("5fIfP");

var $gPfYl = parcelRequire("gPfYl");

var $jbwqm = parcelRequire("jbwqm");

var $4UyCK = parcelRequire("4UyCK");

var $91lou = parcelRequire("91lou");

var $k9ufy = parcelRequire("k9ufy");

var $iA7nF = parcelRequire("iA7nF");

var $ez5GD = parcelRequire("ez5GD");


var $kkwlq = parcelRequire("kkwlq");
const $190423316351a626$var$initialState = {
    isTransitionHomeActivated: false,
    isTransitionHomeModalOpen: false,
    isWelcomeModalActivated: false,
    opsgenieBaseUrl: undefined
};
const $190423316351a626$var$Store = (0, $iXqE5.createStore)({
    initialState: $190423316351a626$var$initialState,
    actions: {
        openTransitionHomeModalAction: ()=>({ setState: setState })=>{
                setState({
                    isTransitionHomeModalOpen: true
                });
            },
        closeTransitionHomeModal: ()=>({ setState: setState })=>{
                setState({
                    isTransitionHomeModalOpen: false
                });
            },
        activateTransitionHome: ()=>({ setState: setState })=>{
                setState({
                    isTransitionHomeActivated: true
                });
            },
        activateWelcomeModal: ()=>({ setState: setState })=>{
                setState({
                    isWelcomeModalActivated: true
                });
            },
        deactivateWelcomeModal: ()=>({ setState: setState })=>{
                setState({
                    isWelcomeModalActivated: false
                });
            }
    },
    name: 'global-changeboarding'
});
const $190423316351a626$export$2285bd7a7d8d4d7b = (0, $3sQ5x.createHook)($190423316351a626$var$Store);
const $190423316351a626$export$e618620d6c810888 = ()=>{
    const [isTransitionHomeLoading, setIsTransitionHomeLoading] = (0, $5uXOq.useState)(false);
    const [{ isTransitionHomeActivated: isTransitionHomeActivated, isWelcomeModalActivated: isWelcomeModalActivated, isTransitionHomeModalOpen: isTransitionHomeModalOpen }, { openTransitionHomeModalAction: openTransitionHomeModalAction, closeTransitionHomeModal: closeTransitionHomeModal, activateTransitionHome: activateTransitionHome, activateWelcomeModal: activateWelcomeModal, deactivateWelcomeModal: deactivateWelcomeModal }] = $190423316351a626$export$2285bd7a7d8d4d7b();
    const [{ usersWithoutAdminRole: usersWithoutAdminRole, usersWithoutCustomRole: usersWithoutCustomRole, stakeholders: stakeholders }, { initialize: initializeUsersAndRoles }] = (0, $k9ufy.useUsersAndRolesStore)();
    const [{ counts: counts, syncedIntegrations: syncedIntegrations, discontinuedIntegrations: discontinuedIntegrations, deprecatedIntegrations: deprecatedIntegrations, incomingCallIntegrations: incomingCallIntegrations }, { initialize: initializeIntegrations, initializeForAdmin: initializeIntegrationsForAdmin }] = (0, $5fIfP.useIntegrationsStore)();
    const [{ notificationPolicies: notificationPolicies, groups: groups, heartbeats: heartbeats }, { initialize: initializeDeprecatedCounts }] = (0, $lLiTq.useDeprecatedCountsStore)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [{ integrations: integrations, connections: connections }, { initialize: initializeChatTools, initializeForTeamAdmin: initializeChatToolsForTeamAdmin }] = (0, $4iQaI.useChatToolsStore)();
    const [{ incidentsCopyStatus: incidentsCopyStatus }, { initialize: initializeIncidentsCopyStatus }] = (0, $luBum.useIncidentsStore)();
    const [{ loading: transitioningStatusLoading, error: transitioningStatusError }, { initialize: initializeTransitioningStatus }] = (0, $91lou.useTransitioningStatus)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const hasJsmAboveStandard = !!tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && appEditions.serviceDesk !== (0, $ldyPw.FREE_EDITION) && appEditions.serviceDesk !== (0, $ldyPw.STANDARD_EDITION);
    const [{ teams: teams }, { initialize: initializeTeams }] = (0, $4UyCK.useTeams)();
    const [{ loading: jnaAppStatusLoading, error: jnaAppStatusError }, { initialize: initializeJNAAppStatus }] = (0, $gPfYl.useJNAAppStatus)();
    const [{ teamAdminStatus: teamAdminStatus }, { initialize: initializeTeamAdminStatus }] = (0, $jbwqm.useTeamAdminStatus)();
    const [{ fetchStatus: fetchStatus, opsgenieBaseUrl: opsgenieBaseUrl }] = (0, $7jF6i.useOpsgenieBaseUrl)('eocChangeboarding');
    const isOpsgenieBaseUrlLoaded = fetchStatus === 'SUCCESS';
    const [ref] = (0, $ieDtd.useQueryParam)((0, $2829d585c82ec887$export$203403aefc029c66));
    const [isWelcomeModalOpen, setIsWelcomeModalOpen] = (0, $5uXOq.useState)(true);
    const { data: data, error: error } = (0, $ez5GD.useOgConsolidationUserState)();
    const { isTransitioning: isTransitioning, loading: tenantLoading, error: tenantError } = (0, $8J6rn.useOgTenantInfo)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isWelcomeModalDisplayedInitialValue = (0, $5uXOq.useRef)(data?.isWelcomeModalDisplayed);
    isWelcomeModalDisplayedInitialValue.current = isWelcomeModalDisplayedInitialValue.current ?? data?.isWelcomeModalDisplayed;
    const isTransitioningInitialValue = (0, $5uXOq.useRef)(isTransitioning);
    isTransitioningInitialValue.current = isTransitioningInitialValue.current ?? isTransitioning;
    // Both of the waiting states are loaded at the SSR and should be already fetched
    // when client starts to render but just in case we should check it
    const isAllWelcomeModalDataLoaded = isWelcomeModalOpen && !tenantLoading && !tenantError && // We need to wait for the data to decide on the final state
    data?.isWelcomeModalDisplayed !== undefined && isOpsgenieBaseUrlLoaded;
    // Do not show the welcome modal until everything is ready
    // This will also prevent a render if there is an error with the initial
    // loading.
    // // We only care for the initial value, it should not change if the
    // // displayed state changes later.
    const finalWelcomeModalIsOpen = isAllWelcomeModalDataLoaded && isTransitioningInitialValue.current && !isWelcomeModalDisplayedInitialValue.current;
    const handleCloseWelcomeModal = ()=>{
        setIsWelcomeModalOpen(false);
    };
    const initializeModalRequests = (0, $5uXOq.useCallback)(()=>{
        const minimalRequiredInitializations = [
            initializeTransitioningStatus(),
            initializeJNAAppStatus()
        ];
        const isUser = !isAdmin && !isSiteAdmin;
        if (isUser) {
            const optimalRequiredInitializations = [
                ...minimalRequiredInitializations,
                initializeTeamAdminStatus(),
                initializeChatToolsForTeamAdmin(),
                initializeIntegrations()
            ];
            return Promise.allSettled(optimalRequiredInitializations).then((0, $iA7nF.multiplePromiseSettler));
        }
        const minimalToolingRequests = [
            initializeChatTools(),
            initializeUsersAndRoles(hasJsmAboveStandard),
            ...minimalRequiredInitializations
        ];
        const optimalToolingRequests = [
            ...minimalToolingRequests,
            initializeTeams(),
            initializeTeamAdminStatus(),
            initializeIntegrationsForAdmin(),
            initializeDeprecatedCounts(),
            initializeIncidentsCopyStatus()
        ];
        return Promise.allSettled(optimalToolingRequests).then((0, $iA7nF.multiplePromiseSettler));
    }, [
        initializeTransitioningStatus,
        initializeJNAAppStatus,
        isAdmin,
        isSiteAdmin,
        initializeChatTools,
        initializeUsersAndRoles,
        hasJsmAboveStandard,
        initializeTeamAdminStatus,
        initializeChatToolsForTeamAdmin,
        initializeTeams,
        initializeIntegrations,
        initializeIntegrationsForAdmin,
        initializeDeprecatedCounts,
        initializeIncidentsCopyStatus
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Close the modal if an error occurs after the initial load
        // If the initial load errors out we don't render the modal at all.
        // This means we generated an error later in the process, let's just
        // get rid of the welcome modal.
        if (data && error) setIsWelcomeModalOpen(false);
    }, [
        error,
        data
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // if the decision data is not loaded don't activate anything
        if (!isAllWelcomeModalDataLoaded) return;
        // If one of the request failed then silently fail and activate transition home
        if (usersWithoutAdminRole.error || usersWithoutCustomRole.error || integrations.error || connections.error || transitioningStatusError || jnaAppStatusError || teams.error || teamAdminStatus.error || counts.error || syncedIntegrations.error || discontinuedIntegrations.error || deprecatedIntegrations.error || incomingCallIntegrations.error || heartbeats.error || notificationPolicies.error || groups.error || incidentsCopyStatus.error || hasJsmAboveStandard && stakeholders.error) {
            deactivateWelcomeModal();
            activateTransitionHome();
            return;
        }
        // if one of the flow is activated or requests are loading then don't activate anything more
        if (isWelcomeModalActivated || isTransitionHomeActivated || usersWithoutAdminRole.loading || usersWithoutCustomRole.loading || integrations.loading || connections.loading || transitioningStatusLoading || jnaAppStatusLoading || teams.loading || teamAdminStatus.loading || counts.loading || syncedIntegrations.loading || discontinuedIntegrations.loading || deprecatedIntegrations.loading || incomingCallIntegrations.loading || heartbeats.loading || notificationPolicies.loading || groups.loading || incidentsCopyStatus.loading || hasJsmAboveStandard && stakeholders.loading) return;
        // if the ref is exist on query parameter, we should activate the modal
        if (ref === (0, $2829d585c82ec887$export$8638ff77a0e20f0f) && finalWelcomeModalIsOpen) {
            initializeModalRequests().then(()=>{
                activateWelcomeModal();
            });
            return;
        }
        // if the ref is not present or we should not display welcome modal and the user is in transitioning state at first then activate transition home
        if (isTransitioningInitialValue.current) {
            deactivateWelcomeModal();
            activateTransitionHome();
        }
    }, [
        activateTransitionHome,
        activateWelcomeModal,
        connections.loading,
        deactivateWelcomeModal,
        finalWelcomeModalIsOpen,
        initializeUsersAndRoles,
        integrations.loading,
        isAllWelcomeModalDataLoaded,
        isTransitionHomeActivated,
        isWelcomeModalActivated,
        ref,
        initializeModalRequests,
        usersWithoutAdminRole.loading,
        usersWithoutCustomRole.loading,
        counts.loading,
        syncedIntegrations.loading,
        discontinuedIntegrations.loading,
        deprecatedIntegrations.loading,
        incomingCallIntegrations.loading,
        transitioningStatusLoading,
        jnaAppStatusLoading,
        usersWithoutAdminRole.error,
        usersWithoutCustomRole.error,
        integrations.error,
        connections.error,
        transitioningStatusError,
        jnaAppStatusError,
        teams.error,
        teams.loading,
        teamAdminStatus.error,
        teamAdminStatus.loading,
        counts.error,
        syncedIntegrations.error,
        discontinuedIntegrations.error,
        deprecatedIntegrations.error,
        incomingCallIntegrations.error,
        heartbeats.error,
        notificationPolicies.error,
        groups.error,
        heartbeats.loading,
        notificationPolicies.loading,
        groups.loading,
        incidentsCopyStatus.loading,
        incidentsCopyStatus.error,
        stakeholders.error,
        stakeholders.loading,
        hasJsmAboveStandard
    ]);
    const openTransitionHomeModal = ()=>{
        setIsTransitionHomeLoading(true);
        return initializeModalRequests().then(()=>{
            activateTransitionHome();
            openTransitionHomeModalAction();
        }).catch(()=>{
            showFlag({
                type: 'error',
                title: (0, $kkwlq.default).errorTitleNonFinal,
                description: (0, $kkwlq.default).errorDescriptionNonFinal,
                actions: [
                    {
                        content: (0, $kkwlq.default).errorActionNonFinal,
                        onClick: openTransitionHomeModal
                    }
                ],
                messageId: 'eoc-changeboarding.controllers.store.global.show-flag.error',
                messageType: 'transactional'
            });
        }).finally(()=>{
            setIsTransitionHomeLoading(false);
        });
    };
    return {
        opsgenieBaseUrl: opsgenieBaseUrl,
        openTransitionHomeModal: openTransitionHomeModal,
        closeTransitionHomeModal: closeTransitionHomeModal,
        activateTransitionHome: activateTransitionHome,
        isTransitionHomeLoading: isTransitionHomeLoading,
        isTransitionHomeActivated: isTransitionHomeActivated,
        isWelcomeModalActivated: isWelcomeModalActivated,
        isTransitionHomeModalOpen: isTransitionHomeModalOpen,
        finalWelcomeModalIsOpen: finalWelcomeModalIsOpen,
        handleCloseWelcomeModal: handleCloseWelcomeModal,
        activateWelcomeModal: activateWelcomeModal
    };
};

});
parcelRegister("7jF6i", function(module, exports) {

$parcel$export(module.exports, "useOpsgenieBaseUrl", () => $1469318d2c6fedc9$export$60d311c8b1ba6c11);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $8r6sb = parcelRequire("8r6sb");
const $1469318d2c6fedc9$export$d4c72bab9d6cc13a = {
    opsgenieBaseUrl: undefined,
    fetchStatus: undefined,
    error: undefined
};
const $1469318d2c6fedc9$var$opsgenieBaseUrlStore = (0, $iXqE5.createStore)({
    name: 'opsgenieBaseUrl',
    initialState: $1469318d2c6fedc9$export$d4c72bab9d6cc13a,
    actions: (0, $8r6sb.actions)
});
const $1469318d2c6fedc9$export$7d5869fb9c3cabbd = (0, $3sQ5x.createHook)($1469318d2c6fedc9$var$opsgenieBaseUrlStore);
const $1469318d2c6fedc9$export$60d311c8b1ba6c11 = (packageName)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [state, { fetchOpsgenieBaseUrl: fetchOpsgenieBaseUrl }] = $1469318d2c6fedc9$export$7d5869fb9c3cabbd();
    const fetchOgBaseUrl = (0, $5uXOq.useCallback)(()=>fetchOpsgenieBaseUrl(createAnalyticsEvent({}), packageName), [
        createAnalyticsEvent,
        fetchOpsgenieBaseUrl,
        packageName
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (state.opsgenieBaseUrl === undefined && !state.fetchStatus) fetchOgBaseUrl();
    }, [
        fetchOgBaseUrl,
        state.opsgenieBaseUrl,
        state.fetchStatus
    ]);
    return [
        state,
        {
            fetchOgBaseUrl: fetchOgBaseUrl
        }
    ];
};

});
parcelRegister("8r6sb", function(module, exports) {

$parcel$export(module.exports, "actions", () => $018567380165a957$export$e324594224ef24da);

var $66VJT = parcelRequire("66VJT");
const $018567380165a957$export$e324594224ef24da = {
    fetchOpsgenieBaseUrl: $66VJT.fetchOpsgenieBaseUrl
};

});
parcelRegister("66VJT", function(module, exports) {

$parcel$export(module.exports, "fetchOpsgenieBaseUrl", () => $0533b309ea677099$export$14e903f188de435b);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");

var $gaED7 = parcelRequire("gaED7");
const $0533b309ea677099$export$14e903f188de435b = (analyticsEvent, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
packageName)=>async ({ getState: getState, setState: setState })=>{
        const { opsgenieBaseUrl: currentOpsgenieBaseUrl, fetchStatus: currentFetchStatus } = getState();
        if (currentOpsgenieBaseUrl !== undefined || // @ts-expect-error - TS2345 - Argument of type 'FetchStatus | undefined' is not assignable to parameter of type '"SUCCESS" | "IN_PROGRESS_FETCH_STATUS"'.
        [
            (0, $gaED7.FETCH_STATUS).inProgress,
            (0, $gaED7.FETCH_STATUS).success
        ].includes(currentFetchStatus)) return;
        setState({
            fetchStatus: (0, $gaED7.FETCH_STATUS).inProgress,
            error: undefined
        });
        try {
            const { baseUrl: baseUrl } = await (0, $7f4tk.default)('/rest/internal/2/opsgenie-base-url');
            analyticsEvent && (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'fetchOgBaseUrl succeeded');
            setState({
                fetchStatus: (0, $gaED7.FETCH_STATUS).success,
                opsgenieBaseUrl: baseUrl
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.trackFetchErrors)({
                error: error,
                id: 'fetchOgBaseUrl',
                packageName: packageName,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                fetchStatus: (0, $gaED7.FETCH_STATUS).error,
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("gaED7", function(module, exports) {

$parcel$export(module.exports, "FETCH_STATUS", () => $9abe9043030eba9b$export$7279934be2ca35bc);
const $9abe9043030eba9b$export$7279934be2ca35bc = {
    inProgress: 'IN_PROGRESS_FETCH_STATUS',
    error: 'ERROR_FETCH_STATUS',
    success: 'SUCCESS'
};

});




const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';

parcelRegister("4iQaI", function(module, exports) {

$parcel$export(module.exports, "ChatToolsContainer", () => $f52f0ab06dfbc1fd$export$a144a4b0356ed94f);
$parcel$export(module.exports, "useChatToolsActions", () => $f52f0ab06dfbc1fd$export$bc3c9253d84bc2bf);
$parcel$export(module.exports, "useChatToolsStore", () => $f52f0ab06dfbc1fd$export$a1388873c4cbfadc);
$parcel$export(module.exports, "useChatToolsConnections", () => $f52f0ab06dfbc1fd$export$74071b1e2400c285);
$parcel$export(module.exports, "useChatToolsIntegrations", () => $f52f0ab06dfbc1fd$export$a985a8cf780397ec);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");

var $pa9q9 = parcelRequire("pa9q9");

var $9OXo1 = parcelRequire("9OXo1");

var $fjrC9 = parcelRequire("fjrC9");

var $ahEC6 = parcelRequire("ahEC6");

var $2H916 = parcelRequire("2H916");

var $8NNKd = parcelRequire("8NNKd");
const $f52f0ab06dfbc1fd$export$d4c72bab9d6cc13a = {
    connections: (0, $fjrC9.emptyResource),
    integrations: (0, $fjrC9.emptyResource),
    loadingConnectionId: '',
    loadingIntegrationId: '',
    mstConnectionUrls: {}
};
const $f52f0ab06dfbc1fd$var$Store = (0, $iXqE5.createStore)({
    initialState: $f52f0ab06dfbc1fd$export$d4c72bab9d6cc13a,
    actions: $8NNKd.actions,
    name: 'chat-tools'
});
const $f52f0ab06dfbc1fd$export$a144a4b0356ed94f = (0, $eW6Xc.createContainer)($f52f0ab06dfbc1fd$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
            const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
            return {
                cloudId: cloudId,
                showFlag: showFlag
            };
        },
        useContainerHook: ()=>{
            const { initialize: initialize } = $f52f0ab06dfbc1fd$export$bc3c9253d84bc2bf();
            const { slackConnectHandler: slackConnectHandler, slackUserLevelAuthoriseHandler: slackUserLevelAuthoriseHandler } = (0, $2H916.useSlackConnection)({
                onSuccess: initialize
            });
            const { mstConnectHandler: mstConnectHandler, adminAuthoriseHandler: adminAuthoriseHandler, mstUserLevelAuthoriseHandler: mstUserLevelAuthoriseHandler } = (0, $ahEC6.useMSTConnection)({
                onSuccess: initialize
            });
            const connectHandler = (0, $5uXOq.useCallback)((event)=>{
                if (!event.data || !event.data.event_id) return;
                if (event.data.event_id === (0, $fjrC9.SLACK_CREATE_CONNECTION_EVENT_ID)) slackConnectHandler(event);
                else if (event.data.event_id === (0, $fjrC9.MSTEAMS_CREATE_CONNECTION_EVENT_ID)) mstConnectHandler(event);
                else if (event.data.event_id === (0, $fjrC9.ADMIN_CONSENT_REQUIRED_EVENT_ID)) adminAuthoriseHandler(event);
                else if (event.data.event_id === (0, $fjrC9.MSTEAMS_USER_LEVEL_AUTH_EVENT_ID)) mstUserLevelAuthoriseHandler(event);
                else if (event.data.event_id === (0, $fjrC9.SLACK_USER_LEVEL_AUTH_EVENT_ID)) slackUserLevelAuthoriseHandler(event);
            }, [
                slackConnectHandler,
                mstConnectHandler,
                adminAuthoriseHandler,
                mstUserLevelAuthoriseHandler,
                slackUserLevelAuthoriseHandler
            ]);
            (0, $5uXOq.useEffect)(()=>{
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.addEventListener('message', connectHandler);
                return ()=>{
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.removeEventListener('message', connectHandler);
                };
            }, [
                connectHandler
            ]);
        }
    })
});
const $f52f0ab06dfbc1fd$export$a1388873c4cbfadc = (0, $3sQ5x.createHook)($f52f0ab06dfbc1fd$var$Store);
const $f52f0ab06dfbc1fd$export$bc3c9253d84bc2bf = (0, $3sQ5x.createActionsHook)($f52f0ab06dfbc1fd$var$Store);
const $f52f0ab06dfbc1fd$export$74071b1e2400c285 = (0, $3sQ5x.createHook)($f52f0ab06dfbc1fd$var$Store, {
    selector: (state)=>state.connections
});
const $f52f0ab06dfbc1fd$export$a985a8cf780397ec = (0, $3sQ5x.createHook)($f52f0ab06dfbc1fd$var$Store, {
    selector: (state)=>state.integrations
});

});
parcelRegister("eW6Xc", function(module, exports) {

$parcel$export(module.exports, "createDefaultEocWrapper", () => $479853350fd92f18$export$a9264953429b0df);
$parcel$export(module.exports, "createContainer", () => $479853350fd92f18$export$26ae5ca175b4ec5a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gg7kZ = parcelRequire("gg7kZ");
/**
 * This component runs the useContainerHook with props that are sent from useSyncContainerProps.
 * We can use all features of react hooks inside here. Also, we created this component outside of
 * the createDefaultEocWrapper due to if we use this inside of the createDefaultEocWrapper,
 * it'll re-render on every child have changed.
 */ function $479853350fd92f18$var$InnerElement({ children: children, useContainerHook: useContainerHook, containerProps: containerProps }) {
    useContainerHook?.(containerProps);
    return children;
}
function $479853350fd92f18$export$a9264953429b0df({ useSyncContainerProps: useSyncContainerProps, useContainerHook: useContainerHook }) {
    return ({ children: children })=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(children)) {
            const containerProps = useSyncContainerProps ? useSyncContainerProps(children.props) : {};
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(children, {
                ...children.props,
                ...containerProps
            }, useContainerHook ? /*#__PURE__*/ (0, $2OMIu.jsx)($479853350fd92f18$var$InnerElement, {
                useContainerHook: useContainerHook,
                containerProps: containerProps,
                children: children.props.children
            }) : children.props.children);
        }
        return null;
    };
}
const $479853350fd92f18$export$26ae5ca175b4ec5a = (store, options)=>{
    const OriginalContainer = (0, $gg7kZ.createContainer)(store, {
        ...options
    });
    const HOC = ({ ...props })=>{
        return options?.Wrapper ? /*#__PURE__*/ (0, $2OMIu.jsx)(options.Wrapper, {
            ...props,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(OriginalContainer, {
                ...props,
                children: props.children
            })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(OriginalContainer, {
            ...props,
            children: props.children
        });
    };
    HOC.displayName = OriginalContainer.displayName + '-HOC'; // To track if error occure because of HOC
    return HOC;
};

});

parcelRegister("fjrC9", function(module, exports) {

$parcel$export(module.exports, "emptyResource", () => $6e16d59f74f8efc1$export$6ed870441802d126);
$parcel$export(module.exports, "SLACK_CREATE_CONNECTION_EVENT_ID", () => $6e16d59f74f8efc1$export$f499a35a9a662ad8);
$parcel$export(module.exports, "SlackErrorCodes", () => $6e16d59f74f8efc1$export$ca77fcbf65183d7a);
$parcel$export(module.exports, "MstErrorCodes", () => $6e16d59f74f8efc1$export$7dd2cc6fd63b5d49);
$parcel$export(module.exports, "JIRA_SUPPORT_LINK", () => $6e16d59f74f8efc1$export$4dc85a478189d1be);
$parcel$export(module.exports, "SLACK_IMAGE_URL", () => $6e16d59f74f8efc1$export$c5dc119cdbeed3dc);
$parcel$export(module.exports, "MST_IMAGE_URL", () => $6e16d59f74f8efc1$export$31622a6434c822c0);
$parcel$export(module.exports, "SLACK_TEXT", () => $6e16d59f74f8efc1$export$d982cc6618dbc0f3);
$parcel$export(module.exports, "MST_TEXT", () => $6e16d59f74f8efc1$export$80d888715be28a18);
$parcel$export(module.exports, "MSTEAMS_CREATE_CONNECTION_EVENT_ID", () => $6e16d59f74f8efc1$export$37e742a41eacef56);
$parcel$export(module.exports, "ADMIN_CONSENT_REQUIRED_EVENT_ID", () => $6e16d59f74f8efc1$export$fe93b230923a5912);
$parcel$export(module.exports, "SLACK_APP_TYPE", () => $6e16d59f74f8efc1$export$2dfb4588bf1292d9);
$parcel$export(module.exports, "MST_APP_TYPE", () => $6e16d59f74f8efc1$export$6838a40356798ab0);
$parcel$export(module.exports, "MSTEAMS_USER_LEVEL_AUTH_EVENT_ID", () => $6e16d59f74f8efc1$export$d1ee2159a22b5eeb);
$parcel$export(module.exports, "SLACK_USER_LEVEL_AUTH_EVENT_ID", () => $6e16d59f74f8efc1$export$40d44b9e20d7bd23);
$parcel$export(module.exports, "TRANSITION_HOME_BUTTON_SPOTLIGHT_NAME", () => $6e16d59f74f8efc1$export$36dc24398b969929);
$parcel$export(module.exports, "HELP_PANEL_SPOTLIGHT_NAME", () => $6e16d59f74f8efc1$export$47504886f4581388);
$parcel$export(module.exports, "UNLOCK_LINK", () => $6e16d59f74f8efc1$export$25520e270c8e452f);
const $6e16d59f74f8efc1$export$6ed870441802d126 = {
    data: null,
    error: null,
    loading: false
};
const $6e16d59f74f8efc1$export$f499a35a9a662ad8 = 'slack_connection_creation_response';
const $6e16d59f74f8efc1$export$ca77fcbf65183d7a = {
    AUTH_CODE_MISSING: 'auth_code_missing',
    CONNECTION_ALREADY_EXIST: 'connection_already_exist',
    CONNECTION_CREATION_FAILED: 'connection_creation_failed',
    FETCH_TOKEN_FAILED: 'failed_to_fetch_token',
    FORBIDDEN_TENANT: 'forbidden_tenant',
    INVALID_STATE: 'invalid_state',
    LINK_EXPIRED: 'link_expired',
    STATE_DECRYPTION_FAILED: 'state_decryption_failed',
    WORKSPACE_MISSMATCH: 'workspace_mismatch'
};
const $6e16d59f74f8efc1$export$7dd2cc6fd63b5d49 = {
    TENANT_CONFLICT: 'tenant_conflict',
    TENANT_MISMATCH: 'tenant_mismatch'
};
const $6e16d59f74f8efc1$export$4dc85a478189d1be = 'https://support.atlassian.com/contact/';
const $6e16d59f74f8efc1$export$c5dc119cdbeed3dc = 'https://resources.opsgeni.us/resources/images/public/integration/logos/SlackApp.png';
const $6e16d59f74f8efc1$export$31622a6434c822c0 = 'https://resources.opsgeni.us/resources/images/public/integration/logos/MSTeams.png';
const $6e16d59f74f8efc1$export$d982cc6618dbc0f3 = 'Slack';
const $6e16d59f74f8efc1$export$80d888715be28a18 = 'Microsoft Teams';
const $6e16d59f74f8efc1$export$37e742a41eacef56 = 'microsoft_create_connection_response';
const $6e16d59f74f8efc1$export$fe93b230923a5912 = 'microsoft_admin_permission_response';
const $6e16d59f74f8efc1$export$2dfb4588bf1292d9 = 'jsm-it-service-desk';
const $6e16d59f74f8efc1$export$6838a40356798ab0 = 'jsm-msteams-app';
const $6e16d59f74f8efc1$export$d1ee2159a22b5eeb = 'microsoft_delegated_permission_response';
const $6e16d59f74f8efc1$export$40d44b9e20d7bd23 = 'slack_user_auth_response';
const $6e16d59f74f8efc1$export$36dc24398b969929 = 'eoc-changeboarding_transition_home_lozenge';
const $6e16d59f74f8efc1$export$47504886f4581388 = 'help-spotlight';
const $6e16d59f74f8efc1$export$25520e270c8e452f = '/jira/settings/products/ops/unlock';

});

parcelRegister("ahEC6", function(module, exports) {

$parcel$export(module.exports, "useMSTConnection", () => $403306d7bad73714$export$4c0b85f07dbab21c);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $fjrC9 = parcelRequire("fjrC9");

var $7EYmk = parcelRequire("7EYmk");

var $jTm7v = parcelRequire("jTm7v");
const $403306d7bad73714$export$4c0b85f07dbab21c = ({ onSuccess: onSuccess })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const mstConnectHandler = (0, $5uXOq.useCallback)((event)=>{
        (0, $7EYmk.chatOpsMessageHandler)({
            event: event,
            requiredEventId: (0, $fjrC9.MSTEAMS_CREATE_CONNECTION_EVENT_ID),
            onSuccessCallback: onSuccess,
            onFailedCallback: (errorCode)=>{
                switch(errorCode){
                    case (0, $fjrC9.MstErrorCodes).TENANT_CONFLICT:
                        showFlag({
                            type: 'error',
                            title: (0, $jTm7v.default).tenantConflictErrorTitleNonFinal,
                            description: (0, $jTm7v.default).tenantConflictErrorDescriptionNonFinal,
                            messageId: 'eoc-changeboarding.services.use-mst-connection.show-flag.error.tenant-conflict',
                            messageType: 'transactional'
                        });
                        break;
                    case (0, $fjrC9.MstErrorCodes).TENANT_MISMATCH:
                        showFlag({
                            type: 'error',
                            title: (0, $jTm7v.default).tenantMissmatchErrorTitleNonFinal,
                            description: (0, $jTm7v.default).tenantMissmatchErrorDescriptionNonFinal,
                            messageId: 'eoc-changeboarding.services.use-mst-connection.show-flag.error.tenant-mismatch',
                            messageType: 'transactional'
                        });
                        break;
                    default:
                        showFlag({
                            type: 'error',
                            title: (0, $jTm7v.default).teamsLoginErrorTitleNonFinal,
                            description: (0, $jTm7v.default).teamsLoginErrorTitleNonFinal,
                            actions: [
                                {
                                    content: (0, $jTm7v.default).contactSupportBtnLabelNonFinal,
                                    href: (0, $fjrC9.JIRA_SUPPORT_LINK),
                                    target: '_blank'
                                }
                            ],
                            messageId: 'eoc-changeboarding.services.use-mst-connection.show-flag.error.default',
                            messageType: 'transactional'
                        });
                }
            }
        });
    }, [
        onSuccess,
        showFlag
    ]);
    const adminAuthoriseHandler = (0, $5uXOq.useCallback)((event)=>{
        (0, $7EYmk.chatOpsMessageHandler)({
            event: event,
            requiredEventId: (0, $fjrC9.ADMIN_CONSENT_REQUIRED_EVENT_ID),
            onSuccessCallback: ()=>{
                onSuccess();
            },
            onFailedCallback: ()=>{
                showFlag({
                    messageId: 'eoc-changeboarding.services.use-mst-connection.show-flag.error.teams-login-error',
                    messageType: 'transactional',
                    type: 'error',
                    title: (0, $jTm7v.default).teamsLoginErrorTitleNonFinal,
                    description: (0, $jTm7v.default).teamsLoginErrorTitleNonFinal,
                    actions: [
                        {
                            content: (0, $jTm7v.default).contactSupportBtnLabelNonFinal,
                            href: (0, $fjrC9.JIRA_SUPPORT_LINK),
                            target: '_blank'
                        }
                    ]
                });
            }
        });
    }, [
        onSuccess,
        showFlag
    ]);
    const mstUserLevelAuthoriseHandler = (0, $5uXOq.useCallback)((event)=>{
        (0, $7EYmk.chatOpsMessageHandler)({
            event: event,
            requiredEventId: (0, $fjrC9.MSTEAMS_USER_LEVEL_AUTH_EVENT_ID),
            onSuccessCallback: ()=>{
                onSuccess();
            }
        });
    }, [
        onSuccess
    ]);
    return {
        mstConnectHandler: mstConnectHandler,
        adminAuthoriseHandler: adminAuthoriseHandler,
        mstUserLevelAuthoriseHandler: mstUserLevelAuthoriseHandler
    };
};

});
parcelRegister("7EYmk", function(module, exports) {

$parcel$export(module.exports, "chatOpsMessageHandler", () => $1e77709525354a34$export$6e5d249d884395f6);
const $1e77709525354a34$export$9fb6e800e02bf3ea = [
    'https://api-private.stg.atlassian.com',
    'https://api-private.atlassian.com'
];
const $1e77709525354a34$export$6e5d249d884395f6 = ({ event: event, onSuccessCallback: onSuccessCallback, onFailedCallback: onFailedCallback, requiredEventId: requiredEventId })=>{
    if (!$1e77709525354a34$export$9fb6e800e02bf3ea.includes(event.origin)) return;
    if (!event.data || !event.data.event_id || !event.data.data || event.data.event_id !== requiredEventId) return;
    const eventData = event.data;
    if (eventData?.data?.success === 'true') onSuccessCallback();
    else if (eventData?.data?.success === 'false') onFailedCallback?.(eventData.data.error);
};

});

parcelRegister("jTm7v", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9f7b988340afc65$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b9f7b988340afc65$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tenantConflictErrorTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.tenant-conflict-error-title-non-final",
        "defaultMessage": "Couldn't connect your Microsoft tenant"
    },
    tenantConflictErrorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.tenant-conflict-error-description-non-final",
        "defaultMessage": "Your Microsoft tenant is connected to a different Jira Service Management site. Disconnect your tenant from the other site or connect a different Microsoft tenant to this Jira Service Management site."
    },
    teamsLoginErrorTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.teams-login-error-title-non-final",
        "defaultMessage": "Couldn't sign in to your Microsoft account"
    },
    teamsLoginErrorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.teams-login-error-description-non-final",
        "defaultMessage": "Please try again or contact support for help."
    },
    contactSupportBtnLabelNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.contact-support-btn-label-non-final",
        "defaultMessage": "Contact support"
    },
    tenantMissmatchErrorTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.tenant-missmatch-error-title-non-final",
        "defaultMessage": "You aren't a member of the Microsoft tenant"
    },
    tenantMissmatchErrorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.tenant-missmatch-error-description-non-final",
        "defaultMessage": "Looks like you aren't part of the Microsoft tenant you're trying to connect with Jira. Join the Microsoft tenant and try again."
    }
});

});


parcelRegister("2H916", function(module, exports) {

$parcel$export(module.exports, "useSlackConnection", () => $5e90d657d68ef7cf$export$3912d4b50c1e1942);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $fjrC9 = parcelRequire("fjrC9");

var $7EYmk = parcelRequire("7EYmk");

var $hzun8 = parcelRequire("hzun8");
const $5e90d657d68ef7cf$export$3912d4b50c1e1942 = ({ onSuccess: onSuccess })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const slackConnectHandler = (0, $5uXOq.useCallback)((event)=>(0, $7EYmk.chatOpsMessageHandler)({
            event: event,
            requiredEventId: (0, $fjrC9.SLACK_CREATE_CONNECTION_EVENT_ID),
            onSuccessCallback: onSuccess,
            onFailedCallback: (errorCode)=>{
                switch(errorCode){
                    case (0, $fjrC9.SlackErrorCodes).AUTH_CODE_MISSING:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).slackNotConnectedTitleNonFinal,
                            description: (0, $hzun8.default).slackAuthoriseErrorDescriptionNonFinal,
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.auth-code-missing',
                            messageType: 'transactional'
                        });
                        break;
                    case (0, $fjrC9.SlackErrorCodes).CONNECTION_ALREADY_EXIST:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).slackNotConnectedTitleNonFinal,
                            description: (0, $hzun8.default).connectionAlreadyExistsDescriptionNonFinal,
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.connection-already-exist',
                            messageType: 'transactional'
                        });
                        break;
                    case (0, $fjrC9.SlackErrorCodes).CONNECTION_CREATION_FAILED:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).slackNotConnectedTitleNonFinal,
                            description: (0, $hzun8.default).connectionFailedDescriptionNonFinal,
                            actions: [
                                {
                                    content: (0, $hzun8.default).slackSupportBtnLabelNonFinal,
                                    href: (0, $fjrC9.JIRA_SUPPORT_LINK),
                                    target: '_blank'
                                }
                            ],
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.connection-creation-failed',
                            messageType: 'transactional'
                        });
                        break;
                    case (0, $fjrC9.SlackErrorCodes).FETCH_TOKEN_FAILED:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).slackNotConnectedTitleNonFinal,
                            description: (0, $hzun8.default).slackAuthoriseErrorDescriptionNonFinal,
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.fetch-token-failed',
                            messageType: 'transactional'
                        });
                        break;
                    case (0, $fjrC9.SlackErrorCodes).FORBIDDEN_TENANT:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).somethingWentWrongTitleNonFinal,
                            description: (0, $hzun8.default).slackContactSupportDescriptionNonFinal,
                            actions: [
                                {
                                    content: (0, $hzun8.default).slackSupportBtnLabelNonFinal,
                                    href: (0, $fjrC9.JIRA_SUPPORT_LINK),
                                    target: '_blank'
                                }
                            ],
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.forbidden-tenant',
                            messageType: 'transactional'
                        });
                        break;
                    case (0, $fjrC9.SlackErrorCodes).INVALID_STATE:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).slackNotConnectedTitleNonFinal,
                            description: (0, $hzun8.default).slackConnectAgainDescriptionNonFinal,
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.invalid-state',
                            messageType: 'transactional'
                        });
                        break;
                    case (0, $fjrC9.SlackErrorCodes).LINK_EXPIRED:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).slackSessionExpiredTitleNonFinal,
                            description: (0, $hzun8.default).slackConnectAgainDescriptionNonFinal,
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.link-expired',
                            messageType: 'transactional'
                        });
                        break;
                    case (0, $fjrC9.SlackErrorCodes).STATE_DECRYPTION_FAILED:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).slackNotConnectedTitleNonFinal,
                            description: (0, $hzun8.default).slackConnectAgainDescriptionNonFinal,
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.state-decryption-failed',
                            messageType: 'transactional'
                        });
                        break;
                    case (0, $fjrC9.SlackErrorCodes).WORKSPACE_MISSMATCH:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).slackWorkspaceMismatchTitleNonFinal,
                            description: (0, $hzun8.default).slackWorkSpaceMissmatchDescriptionNonFinal,
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.workspace-missmatch',
                            messageType: 'transactional'
                        });
                        break;
                    default:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).somethingWentWrongTitleNonFinal,
                            description: (0, $hzun8.default).slackContactSupportDescriptionNonFinal,
                            actions: [
                                {
                                    content: (0, $hzun8.default).slackSupportBtnLabelNonFinal,
                                    href: (0, $fjrC9.JIRA_SUPPORT_LINK),
                                    target: '_blank'
                                }
                            ],
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.default',
                            messageType: 'transactional'
                        });
                        break;
                }
            }
        }), [
        onSuccess,
        showFlag
    ]);
    const slackUserLevelAuthoriseHandler = (0, $5uXOq.useCallback)((event)=>{
        (0, $7EYmk.chatOpsMessageHandler)({
            event: event,
            requiredEventId: (0, $fjrC9.SLACK_USER_LEVEL_AUTH_EVENT_ID),
            onSuccessCallback: ()=>{
                onSuccess();
            }
        });
    }, [
        onSuccess
    ]);
    return {
        slackConnectHandler: slackConnectHandler,
        slackUserLevelAuthoriseHandler: slackUserLevelAuthoriseHandler
    };
};

});
parcelRegister("hzun8", function(module, exports) {

$parcel$export(module.exports, "default", () => $549a18cabad62593$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $549a18cabad62593$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    getSlackConfigurationErrorTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.get-slack-configuration-error-title-non-final",
        "defaultMessage": "We couldn't connect the workspace"
    },
    getSlackConfigurationErrorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.get-slack-configuration-error-description-non-final",
        "defaultMessage": "Wait a moment or refresh the page before trying again."
    },
    slackNotConnectedTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-not-connected-title-non-final",
        "defaultMessage": "Couldn't connect your Slack workspace"
    },
    slackAuthoriseErrorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-authorise-error-description-non-final",
        "defaultMessage": "Your Slack workspace couldn't be authenticated. Please try again."
    },
    connectionAlreadyExistsDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.connection-already-exists-description-non-final",
        "defaultMessage": "Your Slack workspace is already connected to a different Jira Service Management site. Disconnect your workspace from the other site and try again."
    },
    connectionFailedDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.connection-failed-description-non-final",
        "defaultMessage": "Something went wrong. Please try connecting again or contact support for help."
    },
    slackSupportBtnLabelNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-support-btn-label-non-final",
        "defaultMessage": "Contact support"
    },
    somethingWentWrongTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.something-went-wrong-title-non-final",
        "defaultMessage": "Something went wrong"
    },
    slackContactSupportDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-contact-support-description-non-final",
        "defaultMessage": "Please try again or contact support for help."
    },
    slackConnectAgainDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-connect-again-description-non-final",
        "defaultMessage": "Please try connecting your workspace again."
    },
    slackSessionExpiredTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-session-expired-title-non-final",
        "defaultMessage": "Slack session expired"
    },
    slackWorkspaceMismatchTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-workspace-mismatch-title-non-final",
        "defaultMessage": "You aren't a member of the Slack workspace"
    },
    slackWorkSpaceMissmatchDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-work-space-missmatch-description-non-final",
        "defaultMessage": "Looks like you aren't part of the Slack workspace you're trying to connect with Jira. Join the Slack workspace and try again."
    }
});

});


parcelRegister("8NNKd", function(module, exports) {

$parcel$export(module.exports, "actions", () => $dcbe28dff0425066$export$e324594224ef24da);

var $4R6GH = parcelRequire("4R6GH");

var $fjrC9 = parcelRequire("fjrC9");

var $1GqJn = parcelRequire("1GqJn");

var $iA7nF = parcelRequire("iA7nF");

var $jdPtr = parcelRequire("jdPtr");

var $eCYZp = parcelRequire("eCYZp");
const $dcbe28dff0425066$var$getChatToolsConnections = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            connections: {
                data: state.connections.data,
                error: null,
                loading: true
            }
        });
        return $jdPtr.getConnections(cloudId).then((res)=>setState({
                connections: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            // TODO we might display toast
            setState({
                connections: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $dcbe28dff0425066$var$authorizeSlackConnection = (chatSpaceId)=>({ setState: setState }, { cloudId: cloudId })=>{
        setState({
            loadingConnectionId: chatSpaceId
        });
        $jdPtr.getAuthorizeSlackConnectionUrl({
            chatSpaceId: chatSpaceId,
            cloudId: cloudId
        }).then((res)=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(res.data.url, '_blank');
        })// TODO we might display toast
        .finally(()=>{
            setState({
                loadingConnectionId: ''
            });
        });
    };
const $dcbe28dff0425066$var$delegateMSTConnection = (chatSpaceId)=>({ setState: setState }, { cloudId: cloudId })=>{
        setState({
            loadingConnectionId: chatSpaceId
        });
        $jdPtr.getDelegateMSTConnectionUrl({
            chatSpaceId: chatSpaceId,
            cloudId: cloudId
        }).then((res)=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(res.data.url, '_blank');
        })// TODO we might display toast
        .finally(()=>{
            setState({
                loadingConnectionId: ''
            });
        });
    };
const $dcbe28dff0425066$var$getAuthorizeMSTConnectionUrl = (chatSpaceId)=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        if (state.mstConnectionUrls[chatSpaceId]) return Promise.resolve(state.mstConnectionUrls[chatSpaceId]);
        setState({
            loadingConnectionId: chatSpaceId
        });
        return $jdPtr.getaAuthorizeMSTConnectionUrl({
            chatSpaceId: chatSpaceId,
            cloudId: cloudId
        }).then((res)=>{
            state.mstConnectionUrls[chatSpaceId] = res.data.url;
            return res.data.url;
        })// TODO we might display toast
        .finally(()=>{
            setState({
                loadingConnectionId: ''
            });
        });
    };
const $dcbe28dff0425066$var$authorizeMSTConnection = (chatSpaceId)=>({ dispatch: dispatch })=>{
        dispatch($dcbe28dff0425066$var$getAuthorizeMSTConnectionUrl(chatSpaceId)).then((url)=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        });
    };
const $dcbe28dff0425066$var$copyMSTAuthorizationLink = (chatSpaceId)=>({ dispatch: dispatch }, { showFlag: showFlag })=>{
        dispatch($dcbe28dff0425066$var$getAuthorizeMSTConnectionUrl(chatSpaceId)).then((url)=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            ((0, $4R6GH.fg)('jfp-magma-undefined-navigator') ? globalThis.navigator.clipboard : navigator.clipboard).writeText(url || '').then(()=>{
                showFlag?.({
                    messageId: 'eoc-changeboarding.services.store.chat-tools.actions.show-flag.success.copied-success',
                    messageType: 'transactional',
                    type: 'success',
                    title: (0, $eCYZp.default).copiedConfirmationTitleNonFinal,
                    description: (0, $eCYZp.default).copiedSuccessNonFinal
                });
            }).catch(()=>{
                showFlag?.({
                    messageId: 'eoc-changeboarding.services.store.chat-tools.actions.show-flag.error.copied-failed',
                    messageType: 'transactional',
                    type: 'error',
                    title: (0, $eCYZp.default).copiedConfirmationTitleNonFinal,
                    description: (0, $eCYZp.default).copiedFailedNonFinal
                });
            });
        });
    };
const $dcbe28dff0425066$var$getIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            integrations: {
                data: state.integrations.data,
                error: null,
                loading: true
            }
        });
        return $jdPtr.getOgIntegrations(cloudId).then((res)=>setState({
                integrations: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            // TODO we might display toast
            setState({
                integrations: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $dcbe28dff0425066$var$givePermissionToUser = (integration)=>({ setState: setState }, { cloudId: cloudId })=>{
        setState({
            loadingIntegrationId: integration.id
        });
        $jdPtr.getUserAuthorizationUrl({
            cloudId: cloudId,
            chatSpaceType: integration.chatSpaceType,
            chatSpaceId: integration.chatSpaceId
        }).then((res)=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(res.data.url, '_blank');
        })// TODO we might display toast
        .finally(()=>{
            setState({
                loadingIntegrationId: ''
            });
        });
    };
const $dcbe28dff0425066$var$duplicateIntegration = (integration)=>({ setState: setState, dispatch: dispatch }, { cloudId: cloudId, showFlag: showFlag })=>{
        setState({
            loadingIntegrationId: integration.id
        });
        $jdPtr.duplicateIntegration({
            cloudId: cloudId,
            id: integration.id,
            channelId: integration.channelId,
            connectionId: integration.connectionId,
            msTeamsId: integration.msTeamsId
        }).then(()=>{
            dispatch($dcbe28dff0425066$var$getIntegrations());
        }).catch((error)=>{
            if (error.statusCode === 403) {
                showFlag?.({
                    messageId: 'eoc-changeboarding.services.store.chat-tools.actions.show-flag.error.duplicate-not-part-of-channel',
                    messageType: 'transactional',
                    type: 'error',
                    title: (0, $eCYZp.default).duplicateNotPartOfChannelTitleNonFinal,
                    description: (0, $eCYZp.default).duplicateNotPartOfChannelDescriptionNonFinal
                });
                return;
            }
            showFlag?.({
                messageId: 'eoc-changeboarding.services.store.chat-tools.actions.show-flag.error.duplicate-generic-error',
                messageType: 'transactional',
                type: 'error',
                title: (0, $eCYZp.default).duplicateGenericErrorTitleNonFinal,
                description: (0, $eCYZp.default).duplicateGenericErrorDescriptionNonFinal,
                actions: [
                    {
                        content: (0, $eCYZp.default).contactSupportBtnLabelNonFinal,
                        href: (0, $fjrC9.JIRA_SUPPORT_LINK),
                        target: '_blank'
                    }
                ]
            });
        })// TODO we might display toast
        .finally(()=>{
            setState({
                loadingIntegrationId: ''
            });
        });
    };
const $dcbe28dff0425066$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($dcbe28dff0425066$var$getChatToolsConnections()),
            dispatch($dcbe28dff0425066$var$getIntegrations())
        ]).then((0, $iA7nF.multiplePromiseSettler));
const $dcbe28dff0425066$var$initializeForTeamAdmin = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($dcbe28dff0425066$var$getIntegrations())
        ]).then((0, $iA7nF.multiplePromiseSettler));
const $dcbe28dff0425066$export$e324594224ef24da = {
    getChatToolsConnections: $dcbe28dff0425066$var$getChatToolsConnections,
    authorizeSlackConnection: $dcbe28dff0425066$var$authorizeSlackConnection,
    delegateMSTConnection: $dcbe28dff0425066$var$delegateMSTConnection,
    authorizeMSTConnection: $dcbe28dff0425066$var$authorizeMSTConnection,
    copyMSTAuthorizationLink: $dcbe28dff0425066$var$copyMSTAuthorizationLink,
    getIntegrations: $dcbe28dff0425066$var$getIntegrations,
    givePermissionToUser: $dcbe28dff0425066$var$givePermissionToUser,
    duplicateIntegration: $dcbe28dff0425066$var$duplicateIntegration,
    initialize: $dcbe28dff0425066$var$initialize,
    initializeForTeamAdmin: $dcbe28dff0425066$var$initializeForTeamAdmin
};

});
parcelRegister("1GqJn", function(module, exports) {

$parcel$export(module.exports, "createErrorResponse", () => $513a18ba2d1aff95$export$d27409b579447857);
$parcel$export(module.exports, "createDataResponse", () => $513a18ba2d1aff95$export$65a48814b87e4478);
const $513a18ba2d1aff95$export$d27409b579447857 = (error)=>({
        data: null,
        error: error,
        loading: false
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $513a18ba2d1aff95$export$65a48814b87e4478 = (data)=>({
        data: data,
        error: null,
        loading: false
    });

});

parcelRegister("iA7nF", function(module, exports) {

$parcel$export(module.exports, "multiplePromiseSettler", () => $585fda433702dced$export$be72b6e68f6d7c8f);
const $585fda433702dced$export$be72b6e68f6d7c8f = (results)=>{
    if (results.length > 0) {
        const error = results.find((result)=>result.status === 'rejected');
        if (error) throw 'reason' in error ? error.reason : new Error('Unknown error occurred during fetch resource');
        return results;
    }
    return results;
};

});

parcelRegister("jdPtr", function(module, exports) {

$parcel$export(module.exports, "getConnections", () => $4fe7c11842caba6c$export$82b9f8f75cc709b4);
$parcel$export(module.exports, "getAuthorizeSlackConnectionUrl", () => $4fe7c11842caba6c$export$2a70ab934b694f17);
$parcel$export(module.exports, "getOgIntegrations", () => $4fe7c11842caba6c$export$f2efa3535e8bb631);
$parcel$export(module.exports, "getDelegateMSTConnectionUrl", () => $4fe7c11842caba6c$export$58c33fd2c801ef0b);
$parcel$export(module.exports, "getaAuthorizeMSTConnectionUrl", () => $4fe7c11842caba6c$export$d44eb3398b5db37);
$parcel$export(module.exports, "getUserAuthorizationUrl", () => $4fe7c11842caba6c$export$4df1f26230bcb7c);
$parcel$export(module.exports, "duplicateIntegration", () => $4fe7c11842caba6c$export$67ff1e867c2131aa);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $fjrC9 = parcelRequire("fjrC9");
const $4fe7c11842caba6c$export$82b9f8f75cc709b4 = (cloudId)=>{
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/transition/connections`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getConnectionsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4fe7c11842caba6c$export$2a70ab934b694f17 = ({ chatSpaceId: chatSpaceId, cloudId: cloudId })=>{
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorize/slack/connection/create?chatSpaceId=${chatSpaceId}&appType=jsm-it-service-desk&container=transition`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'authorizeSlackConnection',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4fe7c11842caba6c$export$f2efa3535e8bb631 = (cloudId)=>{
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/transition/integrations`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getOgIntegrationsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4fe7c11842caba6c$export$58c33fd2c801ef0b = ({ chatSpaceId: chatSpaceId, cloudId: cloudId })=>{
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorize/msteams/delegated?chatSpaceId=${chatSpaceId}&appType=jsm-msteams-app&container=transition&createConnection=true`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'delegateMSTConnection',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4fe7c11842caba6c$export$d44eb3398b5db37 = ({ chatSpaceId: chatSpaceId, cloudId: cloudId })=>{
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorize/msteams/admin?chatSpaceId=${chatSpaceId}&appType=jsm-msteams-app&container=transition`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'authorizeMSTConnection',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4fe7c11842caba6c$export$4df1f26230bcb7c = ({ cloudId: cloudId, chatSpaceType: chatSpaceType, chatSpaceId: chatSpaceId })=>{
    const appType = chatSpaceType === 'slack' ? (0, $fjrC9.SLACK_APP_TYPE) : (0, $fjrC9.MST_APP_TYPE);
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorise/user?chatSpaceId=${chatSpaceId}&appType=${appType}&source=transition`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getUserAuthorizationUrl',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4fe7c11842caba6c$export$67ff1e867c2131aa = (body)=>{
    const { cloudId: cloudId, id: id, ...restOfBody } = body;
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/transition/integration/duplicate/${id}`;
    return (0, $eusud.performPostRequest)(url, {
        body: JSON.stringify(restOfBody)
    }).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'duplicateIntegration',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};

});

parcelRegister("eCYZp", function(module, exports) {

$parcel$export(module.exports, "default", () => $163319dc0b12cde7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $163319dc0b12cde7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copiedConfirmationTitleNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.copied-confirmation-title-non-final",
        "defaultMessage": "Copied link"
    },
    copiedSuccessNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.copied-success-non-final",
        "defaultMessage": "Share it with your Teams Administrator to ask for their authorization to give permission."
    },
    copiedFailedNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.copied-failed-non-final",
        "defaultMessage": "Something went wrong, please try again? If you need help, contact support."
    },
    duplicateNotPartOfChannelTitleNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.duplicate-not-part-of-channel-title-non-final",
        "defaultMessage": "You aren't a member of the connected channel"
    },
    duplicateNotPartOfChannelDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.duplicate-not-part-of-channel-description-non-final",
        "defaultMessage": "This integration is connected to a chat channel or conversation that you aren't a member of. Join the channel and try again."
    },
    duplicateGenericErrorTitleNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.duplicate-generic-error-title-non-final",
        "defaultMessage": "Couldn't copy your integration"
    },
    duplicateGenericErrorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.duplicate-generic-error-description-non-final",
        "defaultMessage": "Something went wrong while copying your integration to Jira. Try again in some time. If you still need help, contact support."
    },
    contactSupportBtnLabelNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.contact-support-btn-label-non-final",
        "defaultMessage": "Contact support"
    }
});

});



parcelRegister("lLiTq", function(module, exports) {

$parcel$export(module.exports, "DeprecatedCountsContainer", () => $f93024f97192e9da$export$46cb9574b46bee08);
$parcel$export(module.exports, "useDeprecatedCountsStore", () => $f93024f97192e9da$export$7ccc6df7e431e9d5);
$parcel$export(module.exports, "useDeprecatedGroups", () => $f93024f97192e9da$export$a683813e834f13f1);
$parcel$export(module.exports, "useDeprecatedNotificationPolicies", () => $f93024f97192e9da$export$6dd4db40d5822337);
$parcel$export(module.exports, "useDeprecatedHeartbeats", () => $f93024f97192e9da$export$48cc63620d55f335);

var $eW6Xc = parcelRequire("eW6Xc");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $pa9q9 = parcelRequire("pa9q9");

var $9OXo1 = parcelRequire("9OXo1");

var $fjrC9 = parcelRequire("fjrC9");

var $f2DMU = parcelRequire("f2DMU");
const $f93024f97192e9da$export$d4c72bab9d6cc13a = {
    groups: (0, $fjrC9.emptyResource),
    notificationPolicies: (0, $fjrC9.emptyResource),
    heartbeats: (0, $fjrC9.emptyResource)
};
const $f93024f97192e9da$var$Store = (0, $iXqE5.createStore)({
    initialState: $f93024f97192e9da$export$d4c72bab9d6cc13a,
    actions: $f2DMU.actions,
    name: 'deprecated-counts'
});
const $f93024f97192e9da$export$46cb9574b46bee08 = (0, $eW6Xc.createContainer)($f93024f97192e9da$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
            const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
            return {
                cloudId: cloudId,
                showFlag: showFlag
            };
        }
    })
});
const $f93024f97192e9da$export$7ccc6df7e431e9d5 = (0, $3sQ5x.createHook)($f93024f97192e9da$var$Store);
const $f93024f97192e9da$export$a683813e834f13f1 = (0, $3sQ5x.createHook)($f93024f97192e9da$var$Store, {
    selector: (state)=>({
            groups: state.groups,
            hasDeprecatedGroups: (state.groups.data?.count || 0) > 0
        })
});
const $f93024f97192e9da$export$6dd4db40d5822337 = (0, $3sQ5x.createHook)($f93024f97192e9da$var$Store, {
    selector: (state)=>({
            notificationPolicies: state.notificationPolicies,
            hasDeprecatedNotificationPolicies: (state.notificationPolicies.data?.count || 0) > 0
        })
});
const $f93024f97192e9da$export$48cc63620d55f335 = (0, $3sQ5x.createHook)($f93024f97192e9da$var$Store, {
    selector: (state)=>({
            heartbeats: state.heartbeats,
            hasDeprecatedGlobalHeartbeats: (state.heartbeats.data?.globalHeartbeatCount || 0) > 0,
            hasDeprecatedTotalHeartbeats: (state.heartbeats.data?.totalHeartbeatCount || 0) > 0,
            isExceedHeartbeatLimit: (state.heartbeats.data?.totalHeartbeatCount || 0) > 2000
        })
});

});
parcelRegister("f2DMU", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e67700634072e137$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1GqJn = parcelRequire("1GqJn");

var $iA7nF = parcelRequire("iA7nF");

var $jMK2J = parcelRequire("jMK2J");
const $e67700634072e137$var$getDeprecatedGroupsCount = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            groups: {
                data: state.groups.data,
                error: null,
                loading: true
            }
        });
        return $jMK2J.getDeprecatedGroupsCount(cloudId).then((res)=>setState({
                groups: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                groups: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $e67700634072e137$var$getDeprecatedHeartbeatsCount = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            heartbeats: {
                data: state.heartbeats.data,
                error: null,
                loading: true
            }
        });
        return $jMK2J.getDeprecatedHeartbeatsCount(cloudId).then((res)=>setState({
                heartbeats: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                heartbeats: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $e67700634072e137$var$getDeprecatedNotificationPoliciesCount = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            notificationPolicies: {
                data: state.notificationPolicies.data,
                error: null,
                loading: true
            }
        });
        return $jMK2J.getDeprecatedNotificationPoliciesCount(cloudId).then((res)=>setState({
                notificationPolicies: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                notificationPolicies: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $e67700634072e137$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($e67700634072e137$var$getDeprecatedGroupsCount()),
            dispatch($e67700634072e137$var$getDeprecatedHeartbeatsCount()),
            dispatch($e67700634072e137$var$getDeprecatedNotificationPoliciesCount())
        ]).then((0, $iA7nF.multiplePromiseSettler));
const $e67700634072e137$export$e324594224ef24da = {
    getDeprecatedGroupsCount: $e67700634072e137$var$getDeprecatedGroupsCount,
    getDeprecatedHeartbeatsCount: $e67700634072e137$var$getDeprecatedHeartbeatsCount,
    getDeprecatedNotificationPoliciesCount: $e67700634072e137$var$getDeprecatedNotificationPoliciesCount,
    initialize: $e67700634072e137$var$initialize
};

});
parcelRegister("jMK2J", function(module, exports) {

$parcel$export(module.exports, "getDeprecatedGroupsCount", () => $dd71ffe8646c0283$export$67b822a517f03dfe);
$parcel$export(module.exports, "getDeprecatedNotificationPoliciesCount", () => $dd71ffe8646c0283$export$55e3f0e3955ec140);
$parcel$export(module.exports, "getDeprecatedHeartbeatsCount", () => $dd71ffe8646c0283$export$241c0dafce985f59);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $dd71ffe8646c0283$export$67b822a517f03dfe = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/changeboarding/groups`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getDeprecatedGroupsCountEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $dd71ffe8646c0283$export$55e3f0e3955ec140 = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/changeboarding/policies`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getDeprecatedNotificationPoliciesCountEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $dd71ffe8646c0283$export$241c0dafce985f59 = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/heartbeats/changeboarding`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getDeprecatedHeartbeatsCountEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};

});



parcelRegister("luBum", function(module, exports) {

$parcel$export(module.exports, "IncidentsContainer", () => $afaad1410f35f665$export$f504e9eea1c23a86);
$parcel$export(module.exports, "useIncidentsStore", () => $afaad1410f35f665$export$7dfe7cf41f5c2f79);
$parcel$export(module.exports, "useIncidents", () => $afaad1410f35f665$export$23e9cad190e56aee);

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");

var $9OXo1 = parcelRequire("9OXo1");

var $fjrC9 = parcelRequire("fjrC9");

var $5axFq = parcelRequire("5axFq");
const $afaad1410f35f665$export$d4c72bab9d6cc13a = {
    incidentsCopyStatus: (0, $fjrC9.emptyResource)
};
const $afaad1410f35f665$var$Store = (0, $iXqE5.createStore)({
    initialState: $afaad1410f35f665$export$d4c72bab9d6cc13a,
    actions: $5axFq.actions,
    name: 'incidents'
});
const $afaad1410f35f665$export$f504e9eea1c23a86 = (0, $eW6Xc.createContainer)($afaad1410f35f665$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
            return {
                cloudId: cloudId
            };
        }
    })
});
const $afaad1410f35f665$export$7dfe7cf41f5c2f79 = (0, $3sQ5x.createHook)($afaad1410f35f665$var$Store);
const $afaad1410f35f665$export$43131cb4b87347a9 = (0, $3sQ5x.createActionsHook)($afaad1410f35f665$var$Store);
const $afaad1410f35f665$export$23e9cad190e56aee = (0, $3sQ5x.createHook)($afaad1410f35f665$var$Store, {
    selector: (state)=>{
        const { incidentsCopyStatus: incidentsCopyStatus } = state;
        const projectKey = incidentsCopyStatus.data?.payload?.projectKey;
        const status = incidentsCopyStatus.data?.status;
        const errorLength = incidentsCopyStatus.data?.error?.length ?? 0;
        const hasCopyOperationError = errorLength > 0 || status === 'ERROR';
        const isCopied = status === 'SUCCESS' && !!projectKey && errorLength === 0;
        const isCopying = status === 'IN_PROGRESS';
        const canMigrateAgain = incidentsCopyStatus.data?.canMigrateAgain;
        const isEligibleForCopy = (status === 'SUCCESS' || hasCopyOperationError) && canMigrateAgain || status === 'NOT_STARTED';
        const shouldDisplaySuccessBanner = isCopied && canMigrateAgain === false;
        return {
            projectKey: projectKey,
            hasCopyOperationError: hasCopyOperationError,
            isCopied: isCopied,
            isCopying: isCopying,
            isEligibleForCopy: isEligibleForCopy,
            shouldDisplaySuccessBanner: shouldDisplaySuccessBanner
        };
    }
});

});
parcelRegister("5axFq", function(module, exports) {

$parcel$export(module.exports, "actions", () => $365580d5c0599be0$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1GqJn = parcelRequire("1GqJn");

var $iA7nF = parcelRequire("iA7nF");

var $ls6ny = parcelRequire("ls6ny");
const $365580d5c0599be0$var$getIncidentsCopyStatus = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            incidentsCopyStatus: {
                ...state.incidentsCopyStatus,
                loading: true
            }
        });
        return $ls6ny.getIncidentsCopyStatus(cloudId).then((res)=>setState({
                incidentsCopyStatus: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                incidentsCopyStatus: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
// Get status after copy is started and update the state
const $365580d5c0599be0$var$copyIncidents = ()=>({ dispatch: dispatch }, { cloudId: cloudId })=>$ls6ny.copyIncidents(cloudId).then(()=>dispatch($365580d5c0599be0$var$getIncidentsCopyStatus()));
const $365580d5c0599be0$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($365580d5c0599be0$var$getIncidentsCopyStatus())
        ]).then((0, $iA7nF.multiplePromiseSettler));
const $365580d5c0599be0$export$e324594224ef24da = {
    getIncidentsCopyStatus: $365580d5c0599be0$var$getIncidentsCopyStatus,
    copyIncidents: $365580d5c0599be0$var$copyIncidents,
    initialize: $365580d5c0599be0$var$initialize
};

});
parcelRegister("ls6ny", function(module, exports) {

$parcel$export(module.exports, "getIncidentsCopyStatus", () => $1aa4ab063840354a$export$c027992a439e850d);
$parcel$export(module.exports, "copyIncidents", () => $1aa4ab063840354a$export$583821603355a6e2);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $1aa4ab063840354a$export$c027992a439e850d = (cloudId)=>{
    const url = `/gateway/api/jsd/escalator/${cloudId}/api/im-tooling/status`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getIncidentCopyStatusEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $1aa4ab063840354a$export$583821603355a6e2 = (cloudId)=>{
    const url = `/gateway/api/jsd/escalator/${cloudId}/api/im-tooling/start`;
    return (0, $eusud.performPostRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'copyIncidentsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};

});



parcelRegister("5fIfP", function(module, exports) {

$parcel$export(module.exports, "IntegrationsContainer", () => $422ec97ec7702e9c$export$a82408dc976aed12);
$parcel$export(module.exports, "useIntegrationsStore", () => $422ec97ec7702e9c$export$20dfa6771a354e6b);
$parcel$export(module.exports, "useIntegrationCounts", () => $422ec97ec7702e9c$export$d42a7d921bccf5ad);
$parcel$export(module.exports, "useSyncedIntegrations", () => $422ec97ec7702e9c$export$f79da416c7d67657);
$parcel$export(module.exports, "useDiscontinuedIntegrations", () => $422ec97ec7702e9c$export$7145e9baa0c24277);
$parcel$export(module.exports, "useDeprecatedIntegrations", () => $422ec97ec7702e9c$export$1525890f71cafb3f);
$parcel$export(module.exports, "useIncomingCallIntegrations", () => $422ec97ec7702e9c$export$f3c44b9fdca261f2);

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");

var $pa9q9 = parcelRequire("pa9q9");

var $9OXo1 = parcelRequire("9OXo1");

var $fjrC9 = parcelRequire("fjrC9");

var $a1OoE = parcelRequire("a1OoE");
const $422ec97ec7702e9c$export$d4c72bab9d6cc13a = {
    counts: (0, $fjrC9.emptyResource),
    syncedIntegrations: (0, $fjrC9.emptyResource),
    discontinuedIntegrations: (0, $fjrC9.emptyResource),
    deprecatedIntegrations: (0, $fjrC9.emptyResource),
    incomingCallIntegrations: (0, $fjrC9.emptyResource)
};
const $422ec97ec7702e9c$var$Store = (0, $iXqE5.createStore)({
    initialState: $422ec97ec7702e9c$export$d4c72bab9d6cc13a,
    actions: $a1OoE.actions,
    name: 'integrations'
});
const $422ec97ec7702e9c$export$a82408dc976aed12 = (0, $eW6Xc.createContainer)($422ec97ec7702e9c$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
            const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
            return {
                cloudId: cloudId,
                showFlag: showFlag
            };
        }
    })
});
const $422ec97ec7702e9c$export$20dfa6771a354e6b = (0, $3sQ5x.createHook)($422ec97ec7702e9c$var$Store);
const $422ec97ec7702e9c$export$eb083cb7fb078478 = (0, $3sQ5x.createActionsHook)($422ec97ec7702e9c$var$Store);
const $422ec97ec7702e9c$export$d42a7d921bccf5ad = (0, $3sQ5x.createHook)($422ec97ec7702e9c$var$Store, {
    selector: (state)=>({
            counts: state.counts,
            hasIntegrations: (state.counts.data?.totalCount || 0) > 0
        })
});
const $422ec97ec7702e9c$export$f79da416c7d67657 = (0, $3sQ5x.createHook)($422ec97ec7702e9c$var$Store, {
    selector: (state)=>({
            syncedIntegrations: state.syncedIntegrations,
            hasSyncedIntegration: (state.syncedIntegrations.data?.count || 0) > 0
        })
});
const $422ec97ec7702e9c$export$7145e9baa0c24277 = (0, $3sQ5x.createHook)($422ec97ec7702e9c$var$Store, {
    selector: (state)=>({
            discontinuedIntegrations: state.discontinuedIntegrations,
            hasDiscontinuedIntegration: (state.discontinuedIntegrations.data?.count || 0) > 0
        })
});
const $422ec97ec7702e9c$export$1525890f71cafb3f = (0, $3sQ5x.createHook)($422ec97ec7702e9c$var$Store, {
    selector: (state)=>({
            deprecatedIntegrations: state.deprecatedIntegrations,
            hasDeprecatedIntegration: (state.deprecatedIntegrations.data?.count || 0) > 0
        })
});
const $422ec97ec7702e9c$export$f3c44b9fdca261f2 = (0, $3sQ5x.createHook)($422ec97ec7702e9c$var$Store, {
    selector: (state)=>({
            incomingCallIntegrations: state.incomingCallIntegrations,
            hasIncomingCallIntegration: (state.incomingCallIntegrations.data?.count || 0) > 0
        })
});

});
parcelRegister("a1OoE", function(module, exports) {

$parcel$export(module.exports, "actions", () => $280bbd03a95fd3a3$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1GqJn = parcelRequire("1GqJn");

var $iA7nF = parcelRequire("iA7nF");

var $axqwP = parcelRequire("axqwP");
const $280bbd03a95fd3a3$var$getIntegrationCounts = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            counts: {
                ...state.counts,
                loading: true
            }
        });
        return $axqwP.getIntegrationCounts(cloudId).then((res)=>setState({
                counts: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                counts: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $280bbd03a95fd3a3$var$getSyncedIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            syncedIntegrations: {
                ...state.syncedIntegrations,
                loading: true
            }
        });
        return $axqwP.getSyncedIntegrations(cloudId).then((res)=>setState({
                syncedIntegrations: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                syncedIntegrations: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $280bbd03a95fd3a3$var$getDiscontinuedIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            discontinuedIntegrations: {
                ...state.discontinuedIntegrations,
                loading: true
            }
        });
        return $axqwP.getDiscontinuedIntegrations(cloudId).then((res)=>setState({
                discontinuedIntegrations: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                discontinuedIntegrations: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $280bbd03a95fd3a3$var$getDeprecatedIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            deprecatedIntegrations: {
                ...state.deprecatedIntegrations,
                loading: true
            }
        });
        return $axqwP.getDeprecatedIntegrations(cloudId).then((res)=>setState({
                deprecatedIntegrations: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                deprecatedIntegrations: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $280bbd03a95fd3a3$var$getIncomingCallIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            incomingCallIntegrations: {
                ...state.incomingCallIntegrations,
                loading: true
            }
        });
        return $axqwP.getIncomingCallIntegrations(cloudId).then((res)=>setState({
                incomingCallIntegrations: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                incomingCallIntegrations: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $280bbd03a95fd3a3$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($280bbd03a95fd3a3$var$getIntegrationCounts()),
            dispatch($280bbd03a95fd3a3$var$getSyncedIntegrations()),
            dispatch($280bbd03a95fd3a3$var$getDeprecatedIntegrations()),
            dispatch($280bbd03a95fd3a3$var$getDiscontinuedIntegrations())
        ]).then((0, $iA7nF.multiplePromiseSettler));
const $280bbd03a95fd3a3$var$initializeForAdmin = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($280bbd03a95fd3a3$var$getIntegrationCounts()),
            dispatch($280bbd03a95fd3a3$var$getSyncedIntegrations()),
            dispatch($280bbd03a95fd3a3$var$getDeprecatedIntegrations()),
            dispatch($280bbd03a95fd3a3$var$getDiscontinuedIntegrations()),
            dispatch($280bbd03a95fd3a3$var$getIncomingCallIntegrations())
        ]).then((0, $iA7nF.multiplePromiseSettler));
const $280bbd03a95fd3a3$export$e324594224ef24da = {
    initialize: $280bbd03a95fd3a3$var$initialize,
    initializeForAdmin: $280bbd03a95fd3a3$var$initializeForAdmin
};

});
parcelRegister("axqwP", function(module, exports) {

$parcel$export(module.exports, "getIntegrationCounts", () => $4a633d532959c7d6$export$77778a0ed0c6fa6e);
$parcel$export(module.exports, "getSyncedIntegrations", () => $4a633d532959c7d6$export$832e854d2572cc2f);
$parcel$export(module.exports, "getDiscontinuedIntegrations", () => $4a633d532959c7d6$export$fd29039ae6c0f299);
$parcel$export(module.exports, "getDeprecatedIntegrations", () => $4a633d532959c7d6$export$37a9d02f12612e7c);
$parcel$export(module.exports, "getIncomingCallIntegrations", () => $4a633d532959c7d6$export$269a90dd370437b8);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $4a633d532959c7d6$export$77778a0ed0c6fa6e = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/count`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getIntegrationCountsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4a633d532959c7d6$export$832e854d2572cc2f = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/sync`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getSyncedIntegrationsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4a633d532959c7d6$export$fd29039ae6c0f299 = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/discontinued`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getDiscontinuedIntegrationsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4a633d532959c7d6$export$37a9d02f12612e7c = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/deprecated`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getDeprecatedIntegrationsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4a633d532959c7d6$export$269a90dd370437b8 = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/incoming-call`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getIncomingCallIntegrationsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};

});



parcelRegister("gPfYl", function(module, exports) {

$parcel$export(module.exports, "JNAAppStatusContainer", () => $168808b2276040e7$export$ea2d0ab423a74686);
$parcel$export(module.exports, "useJNAAppStatus", () => $168808b2276040e7$export$5d602c3d2ce99e4d);

var $eW6Xc = parcelRequire("eW6Xc");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $pa9q9 = parcelRequire("pa9q9");

var $9OXo1 = parcelRequire("9OXo1");

var $2osG0 = parcelRequire("2osG0");
const $168808b2276040e7$export$d4c72bab9d6cc13a = {
    loading: false,
    error: null
};
const $168808b2276040e7$var$Store = (0, $iXqE5.createStore)({
    initialState: $168808b2276040e7$export$d4c72bab9d6cc13a,
    actions: $2osG0.actions,
    name: 'jna-app-status'
});
// We have a separate store for this b/c we need to fetch the data higher up in the tree
const $168808b2276040e7$export$ea2d0ab423a74686 = (0, $eW6Xc.createContainer)($168808b2276040e7$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
            const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
            return {
                cloudId: cloudId,
                showFlag: showFlag
            };
        }
    })
});
const $168808b2276040e7$export$5d602c3d2ce99e4d = (0, $3sQ5x.createHook)($168808b2276040e7$var$Store);

});
parcelRegister("2osG0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $b5d1450971772bb8$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6QXBz = parcelRequire("6QXBz");
const $b5d1450971772bb8$var$getData = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const { loading: loading } = getState();
        if (loading) // We are already fetching and will receive results, no need to start another request
        return;
        setState({
            loading: true
        });
        return (0, $6QXBz.listJNAAppsEndpoint)(cloudId)// Drop any unnecessary fields
        .then(({ values: values })=>({
                values: values
            })).then(setState).catch((error)=>{
            // TODO: we might display toast
            setState({
                error: error
            });
            throw error;
        }).finally(()=>{
            setState({
                loading: false
            });
        });
    };
const $b5d1450971772bb8$var$initialize = $b5d1450971772bb8$var$getData;
const $b5d1450971772bb8$export$e324594224ef24da = {
    initialize: $b5d1450971772bb8$var$initialize
};

});
parcelRegister("6QXBz", function(module, exports) {

$parcel$export(module.exports, "listJNAAppsEndpoint", () => $585f8a9ffc29380f$export$89c8c108742e6641);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $585f8a9ffc29380f$export$89c8c108742e6641 = (cloudId)=>(0, $eusud.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/onboarding/notification/devices`).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'listJNAAppsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });

});



parcelRegister("jbwqm", function(module, exports) {

$parcel$export(module.exports, "TeamAdminStatusContainer", () => $d393a57ef66828a1$export$1c30a658c5f5a989);
$parcel$export(module.exports, "useTeamAdminStatus", () => $d393a57ef66828a1$export$8e6e1b9570cbbe18);
$parcel$export(module.exports, "useIsTeamAdmin", () => $d393a57ef66828a1$export$1e85709af32c9e77);

var $eW6Xc = parcelRequire("eW6Xc");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $9OXo1 = parcelRequire("9OXo1");

var $fjrC9 = parcelRequire("fjrC9");

var $u313a = parcelRequire("u313a");
const $d393a57ef66828a1$export$d4c72bab9d6cc13a = {
    teamAdminStatus: (0, $fjrC9.emptyResource)
};
const $d393a57ef66828a1$var$Store = (0, $iXqE5.createStore)({
    initialState: $d393a57ef66828a1$export$d4c72bab9d6cc13a,
    actions: $u313a.actions,
    name: 'team-admin-status'
});
const $d393a57ef66828a1$export$1c30a658c5f5a989 = (0, $eW6Xc.createContainer)($d393a57ef66828a1$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
            return {
                cloudId: cloudId
            };
        }
    })
});
const $d393a57ef66828a1$export$8e6e1b9570cbbe18 = (0, $3sQ5x.createHook)($d393a57ef66828a1$var$Store);
const $d393a57ef66828a1$export$1e85709af32c9e77 = (0, $3sQ5x.createHook)($d393a57ef66828a1$var$Store, {
    selector: (state)=>({
            isTeamAdmin: state.teamAdminStatus.data?.isTeamAdmin
        })
});

});
parcelRegister("u313a", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e9ada8a126ed29ad$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1GqJn = parcelRequire("1GqJn");

var $iA7nF = parcelRequire("iA7nF");

var $4NBj0 = parcelRequire("4NBj0");
const $e9ada8a126ed29ad$var$getTeamAdminStatus = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            teamAdminStatus: {
                data: state.teamAdminStatus.data,
                error: null,
                loading: true
            }
        });
        return $4NBj0.getTeamAdminStatus(cloudId).then((res)=>setState({
                teamAdminStatus: (0, $1GqJn.createDataResponse)(res)
            })).catch((error)=>{
            setState({
                teamAdminStatus: (0, $1GqJn.createErrorResponse)(error)
            });
            throw error;
        });
    };
const $e9ada8a126ed29ad$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($e9ada8a126ed29ad$var$getTeamAdminStatus())
        ]).then((0, $iA7nF.multiplePromiseSettler));
const $e9ada8a126ed29ad$export$e324594224ef24da = {
    getTeamAdminStatus: $e9ada8a126ed29ad$var$getTeamAdminStatus,
    initialize: $e9ada8a126ed29ad$var$initialize
};

});
parcelRegister("4NBj0", function(module, exports) {

$parcel$export(module.exports, "getTeamAdminStatus", () => $139f0b131a39dfb8$export$454301be74c0d0f5);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $139f0b131a39dfb8$export$454301be74c0d0f5 = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/teams/has-any-team-admin-role`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getTeamAdminStatusEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};

});



parcelRegister("4UyCK", function(module, exports) {

$parcel$export(module.exports, "TeamsContainer", () => $68ff89a0c54ca969$export$1af14301d7a47977);
$parcel$export(module.exports, "useTeams", () => $68ff89a0c54ca969$export$6fe02dcc2001dcb0);

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");

var $pa9q9 = parcelRequire("pa9q9");

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");

var $fjrC9 = parcelRequire("fjrC9");

var $61UG4 = parcelRequire("61UG4");
const $68ff89a0c54ca969$export$d4c72bab9d6cc13a = {
    teams: (0, $fjrC9.emptyResource),
    hasTeams: false
};
const $68ff89a0c54ca969$var$Store = (0, $iXqE5.createStore)({
    initialState: $68ff89a0c54ca969$export$d4c72bab9d6cc13a,
    actions: $61UG4.actions,
    name: 'teams-step'
});
const $68ff89a0c54ca969$export$1af14301d7a47977 = (0, $eW6Xc.createContainer)($68ff89a0c54ca969$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { data: orgId } = (0, $14XJw.useOrgId)();
            const { atlassianAccountId: atlassianAccountId, cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
            const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
            return {
                orgId: orgId,
                accountId: atlassianAccountId,
                siteId: cloudId,
                showFlag: showFlag
            };
        }
    })
});
const $68ff89a0c54ca969$export$381ea4f5dcfe14e8 = (0, $3sQ5x.createHook)($68ff89a0c54ca969$var$Store);
const $68ff89a0c54ca969$export$61c2ead0c7de7c67 = (0, $3sQ5x.createActionsHook)($68ff89a0c54ca969$var$Store);
const $68ff89a0c54ca969$export$6fe02dcc2001dcb0 = (0, $3sQ5x.createHook)($68ff89a0c54ca969$var$Store, {
    selector: (state)=>({
            teams: state.teams,
            hasTeams: (state.teams.data?.entities.length || 0) > 0
        })
});

});
parcelRegister("61UG4", function(module, exports) {

$parcel$export(module.exports, "actions", () => $8b1c9aa8723d62ee$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1GqJn = parcelRequire("1GqJn");

var $iA7nF = parcelRequire("iA7nF");

var $pjOsd = parcelRequire("pjOsd");
const $8b1c9aa8723d62ee$var$getTeams = ()=>({ setState: setState, getState: getState }, { orgId: orgId, siteId: siteId, accountId: accountId })=>{
        if (!orgId) throw new Error('TeamsContainer-actions-getTeams-orgId must be defined to search teams');
        if (!accountId) {
            const error = new Error('TeamsContainer-useSyncContainerProps-atlassianAccountId must be defined to search teams');
            error.skipSentry = true;
            throw error;
        }
        const state = getState();
        setState({
            teams: {
                data: state.teams.data,
                error: null,
                loading: true
            }
        });
        return $pjOsd.searchTeamsEndpoint({
            orgId: orgId,
            siteId: siteId,
            accountId: accountId
        }).then((res)=>setState({
                teams: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                teams: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $8b1c9aa8723d62ee$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($8b1c9aa8723d62ee$var$getTeams())
        ]).then((0, $iA7nF.multiplePromiseSettler));
const $8b1c9aa8723d62ee$export$e324594224ef24da = {
    getTeams: $8b1c9aa8723d62ee$var$getTeams,
    initialize: $8b1c9aa8723d62ee$var$initialize
};

});
parcelRegister("pjOsd", function(module, exports) {

$parcel$export(module.exports, "searchTeamsEndpoint", () => $ef017c4083dc5c7f$export$b6cad9b1c9a0c16e);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $ef017c4083dc5c7f$export$b6cad9b1c9a0c16e = ({ orgId: orgId, siteId: siteId, accountId: accountId })=>{
    const url = '/gateway/api/v4/teams/search';
    return (0, $eusud.performPostRequest)(url, {
        method: 'POST',
        body: JSON.stringify({
            organizationId: orgId,
            siteId: siteId,
            membership: {
                memberAccountIds: [
                    accountId
                ]
            },
            sortBy: [
                {
                    field: 'displayName',
                    order: 'asc'
                }
            ],
            limit: 100
        })
    }).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'searchTeamsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};

});



parcelRegister("91lou", function(module, exports) {

$parcel$export(module.exports, "TransitioningStatusContainer", () => $b8070b541c362c00$export$99720b5470b975d9);
$parcel$export(module.exports, "useTransitioningStatus", () => $b8070b541c362c00$export$534e97dc293df05a);
$parcel$export(module.exports, "useTransitioningStatusActions", () => $b8070b541c362c00$export$5097f959a9aa62ee);

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");

var $pa9q9 = parcelRequire("pa9q9");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $9OXo1 = parcelRequire("9OXo1");

var $8ALXm = parcelRequire("8ALXm");
const $b8070b541c362c00$export$d4c72bab9d6cc13a = {
    loading: false,
    error: null,
    isJnaAppDownloaded: false,
    ogAppExistsAtTransitioningStart: false,
    isRBNEnabled: true,
    areOgRulesDuplicated: false,
    areOgAppsDeactivated: false,
    jnaAppDownloadedRatio: 0,
    jnaAppDownloadedUsersCount: 0
};
const $b8070b541c362c00$var$Store = (0, $iXqE5.createStore)({
    initialState: $b8070b541c362c00$export$d4c72bab9d6cc13a,
    actions: $8ALXm.actions,
    name: 'transitioning-status'
});
const $b8070b541c362c00$export$99720b5470b975d9 = (0, $eW6Xc.createContainer)($b8070b541c362c00$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
            const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
            const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
            const isPrimaryAdmin = (0, $itmJb.useIsAdmin)();
            return {
                cloudId: cloudId,
                showFlag: showFlag,
                isAdmin: isSiteAdmin || isPrimaryAdmin
            };
        }
    })
});
const $b8070b541c362c00$export$534e97dc293df05a = (0, $3sQ5x.createHook)($b8070b541c362c00$var$Store);
const $b8070b541c362c00$export$5097f959a9aa62ee = (0, $3sQ5x.createActionsHook)($b8070b541c362c00$var$Store);

});
parcelRegister("8ALXm", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0d76ba88b9164f9c$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iA7nF = parcelRequire("iA7nF");

var $i19HX = parcelRequire("i19HX");
const $0d76ba88b9164f9c$var$getData = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId, isAdmin: isAdmin })=>{
        const { loading: loading } = getState();
        if (loading) // We are already fetching and receive results, no need to start another request
        return;
        setState({
            loading: true
        });
        return Promise.allSettled([
            (0, $i19HX.getNotificationPreferences)(cloudId),
            (0, $i19HX.getTransitioningStatus)(cloudId, isAdmin)
        ]).then((0, $iA7nF.multiplePromiseSettler)).then(([notificationPreferencesResult, transitioningStatusResult])=>{
            if (notificationPreferencesResult.status === 'rejected' || transitioningStatusResult.status === 'rejected') throw new Error('All promises should be fulfilled in then callback');
            return {
                ...notificationPreferencesResult.value,
                ...transitioningStatusResult.value
            };
        }).then(setState).catch((error)=>{
            // TODO: we might display toast
            setState({
                error: error
            });
            throw error;
        }).finally(()=>{
            setState({
                loading: false
            });
        });
    };
const $0d76ba88b9164f9c$var$initialize = $0d76ba88b9164f9c$var$getData;
const $0d76ba88b9164f9c$var$deactivateOgApps = ()=>async ({ setState: setState })=>{
        setState({
            areOgAppsDeactivated: true
        });
    };
const $0d76ba88b9164f9c$export$e324594224ef24da = {
    initialize: $0d76ba88b9164f9c$var$initialize,
    deactivateOgApps: $0d76ba88b9164f9c$var$deactivateOgApps
};

});
parcelRegister("i19HX", function(module, exports) {

$parcel$export(module.exports, "getTransitioningStatus", () => $af3bd5a83ad05315$export$6b245964f40af86a);
$parcel$export(module.exports, "getNotificationPreferences", () => $af3bd5a83ad05315$export$60e139c3026f21bc);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $af3bd5a83ad05315$export$6b245964f40af86a = (cloudId, isAdmin)=>(0, $eusud.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/onboarding/transitioning?isAdmin=${isAdmin}`).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getTransitioningStatus',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
const $af3bd5a83ad05315$export$60e139c3026f21bc = (cloudId)=>(0, $eusud.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/notification-preferences`).then((res)=>// TODO: return name and role if it is necessary for the UI
        ({
            isRBNEnabled: !!res.roleBasedNotificationName
        })).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getNotificationPreferences',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });

});



parcelRegister("k9ufy", function(module, exports) {

$parcel$export(module.exports, "UsersAndRolesContainer", () => $f5ea6d8f67a25a35$export$8641f4275dfb350f);
$parcel$export(module.exports, "useUsersAndRolesStore", () => $f5ea6d8f67a25a35$export$4c1f48a2f8c5d25);
$parcel$export(module.exports, "useUserAndRolesActions", () => $f5ea6d8f67a25a35$export$3a5577e95dd8ebcf);
$parcel$export(module.exports, "useGetUsersWithoutAdminRole", () => $f5ea6d8f67a25a35$export$208cf6e453d9959);
$parcel$export(module.exports, "useGetUsersWithoutCustomRole", () => $f5ea6d8f67a25a35$export$f97f67eb73b757d4);
$parcel$export(module.exports, "useStakeholders", () => $f5ea6d8f67a25a35$export$57e32456ebc09be3);

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");

var $9OXo1 = parcelRequire("9OXo1");

var $fjrC9 = parcelRequire("fjrC9");

var $41HN4 = parcelRequire("41HN4");
const $f5ea6d8f67a25a35$var$initialState = {
    usersWithoutAdminRole: (0, $fjrC9.emptyResource),
    usersWithoutCustomRole: (0, $fjrC9.emptyResource),
    stakeholders: (0, $fjrC9.emptyResource)
};
const $f5ea6d8f67a25a35$var$Store = (0, $iXqE5.createStore)({
    initialState: $f5ea6d8f67a25a35$var$initialState,
    actions: $41HN4.actions,
    name: 'user-section'
});
const $f5ea6d8f67a25a35$export$8641f4275dfb350f = (0, $eW6Xc.createContainer)($f5ea6d8f67a25a35$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
            return {
                cloudId: cloudId
            };
        }
    })
});
const $f5ea6d8f67a25a35$export$4c1f48a2f8c5d25 = (0, $3sQ5x.createHook)($f5ea6d8f67a25a35$var$Store);
const $f5ea6d8f67a25a35$export$3a5577e95dd8ebcf = (0, $3sQ5x.createActionsHook)($f5ea6d8f67a25a35$var$Store);
const $f5ea6d8f67a25a35$export$208cf6e453d9959 = (0, $3sQ5x.createHook)($f5ea6d8f67a25a35$var$Store, {
    selector: (state)=>state.usersWithoutAdminRole
});
const $f5ea6d8f67a25a35$export$f97f67eb73b757d4 = (0, $3sQ5x.createHook)($f5ea6d8f67a25a35$var$Store, {
    selector: (state)=>state.usersWithoutCustomRole
});
const $f5ea6d8f67a25a35$export$57e32456ebc09be3 = (0, $3sQ5x.createHook)($f5ea6d8f67a25a35$var$Store, {
    selector: (state)=>state.stakeholders
});

});
parcelRegister("41HN4", function(module, exports) {

$parcel$export(module.exports, "actions", () => $83453406eb32a656$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1GqJn = parcelRequire("1GqJn");

var $iA7nF = parcelRequire("iA7nF");

var $2VwYU = parcelRequire("2VwYU");
const $83453406eb32a656$var$getUsersWithoutAdminRole = ()=>({ setState: setState }, { cloudId: cloudId })=>{
        setState({
            usersWithoutAdminRole: {
                data: null,
                error: null,
                loading: true
            }
        });
        return $2VwYU.getUsersWithoutAdminRole(cloudId).then((res)=>{
            setState({
                usersWithoutAdminRole: (0, $1GqJn.createDataResponse)(res)
            });
        }).catch((err)=>{
            // TODO we might display toast
            setState({
                usersWithoutAdminRole: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $83453406eb32a656$var$getUsersWithoutCustomRole = ()=>({ setState: setState }, { cloudId: cloudId })=>{
        setState({
            usersWithoutCustomRole: {
                data: null,
                error: null,
                loading: true
            }
        });
        return $2VwYU.getUsersWithoutCustomRole(cloudId).then((res)=>{
            setState({
                usersWithoutCustomRole: (0, $1GqJn.createDataResponse)(res)
            });
        }).catch((err)=>{
            // TODO we might display toast
            setState({
                usersWithoutCustomRole: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $83453406eb32a656$var$getStakeholders = ()=>({ setState: setState }, { cloudId: cloudId })=>{
        setState({
            stakeholders: {
                data: null,
                error: null,
                loading: true
            }
        });
        return $2VwYU.getStakeholders(cloudId).then((res)=>{
            setState({
                stakeholders: (0, $1GqJn.createDataResponse)(res)
            });
        }).catch((err)=>{
            // TODO we might display toast
            setState({
                stakeholders: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $83453406eb32a656$var$initialize = (hasJsmAboveStandard)=>({ dispatch: dispatch })=>{
        if (hasJsmAboveStandard) return Promise.allSettled([
            dispatch($83453406eb32a656$var$getUsersWithoutCustomRole()),
            dispatch($83453406eb32a656$var$getUsersWithoutAdminRole()),
            dispatch($83453406eb32a656$var$getStakeholders())
        ]).then((0, $iA7nF.multiplePromiseSettler));
        return Promise.allSettled([
            dispatch($83453406eb32a656$var$getUsersWithoutCustomRole()),
            dispatch($83453406eb32a656$var$getUsersWithoutAdminRole())
        ]).then((0, $iA7nF.multiplePromiseSettler));
    };
const $83453406eb32a656$export$e324594224ef24da = {
    getUsersWithoutAdminRole: $83453406eb32a656$var$getUsersWithoutAdminRole,
    getUsersWithoutCustomRole: $83453406eb32a656$var$getUsersWithoutCustomRole,
    getStakeholders: $83453406eb32a656$var$getStakeholders,
    initialize: $83453406eb32a656$var$initialize
};

});
parcelRegister("2VwYU", function(module, exports) {

$parcel$export(module.exports, "getStakeholders", () => $867327124ecc2dfa$export$30370cfbc42a80a5);
$parcel$export(module.exports, "getUsersWithoutAdminRole", () => $867327124ecc2dfa$export$1ec19cfa7c383f0d);
$parcel$export(module.exports, "getUsersWithoutCustomRole", () => $867327124ecc2dfa$export$64f73bf174c9014a);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $867327124ecc2dfa$export$30370cfbc42a80a5 = (cloudId)=>(0, $eusud.performPostRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/roles/filter`, {
        body: JSON.stringify({
            limit: '10',
            offset: 0,
            roles: [
                'Stakeholder'
            ]
        })
    }).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getStakeholders',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
    // throw err;
    });
const $867327124ecc2dfa$export$1ec19cfa7c383f0d = (cloudId)=>(0, $eusud.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/permissionDifference/admin`).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getUsersWithoutAdminRole',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
const $867327124ecc2dfa$export$64f73bf174c9014a = (cloudId)=>(0, $eusud.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/permissionDifference/customRole`).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getUsersWithoutCustomRole',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });

});



const $2829d585c82ec887$export$203403aefc029c66 = 'ref';
const $2829d585c82ec887$export$8638ff77a0e20f0f = 'opsgenie';

parcelRegister("kkwlq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6abecfa22ab77d89$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6abecfa22ab77d89$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitleNonFinal: {
        "id": "eoc-changeboarding.controllers.store.global.error-title-non-final",
        "defaultMessage": "Couldn't open the guide"
    },
    errorDescriptionNonFinal: {
        "id": "eoc-changeboarding.controllers.store.global.error-description-non-final",
        "defaultMessage": "Something went wrong. Reload the page and try again."
    },
    errorActionNonFinal: {
        "id": "eoc-changeboarding.controllers.store.global.error-action-non-final",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("aTWms", function(module, exports) {

$parcel$export(module.exports, "ChangeboardingProviders", () => $a85523c42764cbee$export$935fa8923574c4cf);

var $5uXOq = parcelRequire("5uXOq");

var $4iQaI = parcelRequire("4iQaI");

var $lLiTq = parcelRequire("lLiTq");

var $luBum = parcelRequire("luBum");

var $5fIfP = parcelRequire("5fIfP");

var $gPfYl = parcelRequire("gPfYl");

var $jbwqm = parcelRequire("jbwqm");

var $4UyCK = parcelRequire("4UyCK");

var $91lou = parcelRequire("91lou");

var $k9ufy = parcelRequire("k9ufy");
const $a85523c42764cbee$var$MinimalToolingProviders = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9ufy.UsersAndRolesContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4iQaI.ChatToolsContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPfYl.JNAAppStatusContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $91lou.TransitioningStatusContainer), {
        isGlobal: true
    }, children))));
const $a85523c42764cbee$export$935fa8923574c4cf = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4UyCK.TeamsContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbwqm.TeamAdminStatusContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5fIfP.IntegrationsContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLiTq.DeprecatedCountsContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBum.IncidentsContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a85523c42764cbee$var$MinimalToolingProviders, null, children))))));
};

});

const $8bd01cb292c29cb9$export$75f90732d1326d15 = 5;

parcelRegister("83g2V", function(module, exports) {

$parcel$export(module.exports, "Wizard", () => $aed802527fc8c816$export$c6a37f46d6629cf2);

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $9fuVs = parcelRequire("9fuVs");

var $7NYq5 = parcelRequire("7NYq5");


var $hu9ei = parcelRequire("hu9ei");

var $ab6K3 = parcelRequire("ab6K3");

var $78zm0 = parcelRequire("78zm0");

var $6pFzR = parcelRequire("6pFzR");

var $1IRNJ = parcelRequire("1IRNJ");
const $aed802527fc8c816$export$c6a37f46d6629cf2 = ({ isOpen: isOpen, onClose: onClose, defaultStep: defaultStep = 1, onUnlock: onUnlock })=>{
    const [currentStep, setCurrentStep] = (0, $5uXOq.useState)(defaultStep);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        height: 700,
        width: 1100,
        onClose: onClose,
        shouldCloseOnOverlayClick: false,
        messageId: "eoc-changeboarding.ui.wizard.optimal.modal",
        messageType: "transactional"
    }, currentStep === 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $78zm0.StepOne), {
        onAction: setCurrentStep,
        onClose: onClose
    }), currentStep === 2 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1IRNJ.StepTwo), {
        onAction: setCurrentStep,
        onClose: onClose
    }), currentStep === 3 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6pFzR.StepThree), {
        onAction: setCurrentStep,
        onClose: onClose
    }), currentStep === 4 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ab6K3.StepFour), {
        onAction: setCurrentStep,
        onClose: onClose,
        onUnlock: onUnlock
    }), currentStep === 5 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hu9ei.StepFive), {
        onClose: onClose,
        // If started from step 5, it means we weren't the one unlocking it
        isFirstUnlocked: defaultStep !== (0, $8bd01cb292c29cb9$export$75f90732d1326d15)
    }))));
};

});
parcelRegister("hu9ei", function(module, exports) {

$parcel$export(module.exports, "StepFive", () => $2a7668c353785674$export$782dfa47fc019134);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
var $2rqOp = parcelRequire("2rqOp");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $llLmv = parcelRequire("llLmv");

var $bsatB = parcelRequire("bsatB");

var $1PJY5 = parcelRequire("1PJY5");

var $dL1CG = parcelRequire("dL1CG");

var $585jx = parcelRequire("585jx");

var $6BT89 = parcelRequire("6BT89");

var $ez5GD = parcelRequire("ez5GD");

var $6FtII = parcelRequire("6FtII");
const $2a7668c353785674$export$782dfa47fc019134 = ({ onClose: onClose, isFirstUnlocked: isFirstUnlocked = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { openTransitionHomeModal: openTransitionHomeModal, isTransitionHomeLoading: isTransitionHomeLoading, activateTransitionHome: activateTransitionHome } = (0, $6BT89.useGlobalChangeboarding)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { update: update } = (0, $ez5GD.useOgConsolidationUserState)();
    (0, $5uXOq.useEffect)(()=>{
        // Immediately update user state
        update({
            isWelcomeModalDisplayed: true
        }).catch(()=>{
            // If an error occurs, close the modal
            onClose();
        });
    // Here we don't include onClose as it is probably an inlined function
    // with a state update. It is totally fine to call the initial function
    // passed in when the update is first called even though it is now stale.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        update
    ]);
    const primaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        onClick: ()=>{
            openTransitionHomeModal().then(()=>{
                activateTransitionHome();
                onClose();
            });
        },
        appearance: "primary",
        isLoading: isTransitionHomeLoading
    }, formatMessage((0, $585jx.messages).openShiftingGuideButtonNonFinal));
    const secondaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: (e, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'closeTransitionWizardInUnlockStep');
            onClose();
            activateTransitionHome();
        },
        appearance: "subtle"
    }, formatMessage((0, $585jx.messages).remindMeLaterButtonNonFinal));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dL1CG.Layout), {
        vector: {
            light: isFirstUnlocked ? (0, (/*@__PURE__*/$parcel$interopDefault($llLmv))) : (0, (/*@__PURE__*/$parcel$interopDefault($1PJY5))),
            dark: isFirstUnlocked ? (0, (/*@__PURE__*/$parcel$interopDefault($llLmv))) : (0, (/*@__PURE__*/$parcel$interopDefault($bsatB)))
        },
        currentStep: 5,
        actionButtons: {
            primary: primaryActionButton,
            secondary: secondaryActionButton
        },
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6FtII.Content), {
        isFirstUnlocked: isFirstUnlocked,
        isAdmin: isAdmin || isSiteAdmin
    }));
};

});
parcelRegister("llLmv", function(module, exports) {
module.exports = new URL("step_five_vector.64bb3354.png", import.meta.url).toString();

});

parcelRegister("bsatB", function(module, exports) {
module.exports = new URL("step_five_vector_dark_optimal.d2b5a6c3.png", import.meta.url).toString();

});

parcelRegister("1PJY5", function(module, exports) {
module.exports = new URL("step_five_vector_light_optimal.7f2549c4.png", import.meta.url).toString();

});

parcelRegister("dL1CG", function(module, exports) {

$parcel$export(module.exports, "Layout", () => $af3a308a6aaf1dd3$export$c84671f46d6a1ca);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $84THj = parcelRequire("84THj");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $hxoiH = parcelRequire("hxoiH");

var $koVbs = parcelRequire("koVbs");

var $7X5Yl = parcelRequire("7X5Yl");

var $jl2BD = parcelRequire("jl2BD");

var $585jx = parcelRequire("585jx");
const $af3a308a6aaf1dd3$export$c84671f46d6a1ca = ({ children: children, vector: vector, actionButtons: actionButtons, currentStep: currentStep, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const theme = (0, $hxoiH.default)();
    const isDarkMode = theme.colorMode === 'dark';
    const shouldShowStep = currentStep !== 5;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $af3a308a6aaf1dd3$var$contentContainerStyles,
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        xcss: [
            $af3a308a6aaf1dd3$var$halfWidthStyles
        ],
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        rowGap: "space.100",
        xcss: [
            $af3a308a6aaf1dd3$var$contentStyles
        ]
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: [
            $af3a308a6aaf1dd3$var$actionStyles
        ],
        justifyContent: shouldShowStep ? 'space-between' : 'end',
        alignItems: "center"
    }, shouldShowStep && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $af3a308a6aaf1dd3$var$locatorStyles
    }, formatMessage((0, $585jx.messages).stepLocatorNonFinal, {
        currentStep: currentStep
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        columnGap: "space.100"
    }, actionButtons.secondary, actionButtons.primary))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: [
            $af3a308a6aaf1dd3$var$halfWidthStyles,
            $af3a308a6aaf1dd3$var$rightColumnStyles,
            isDarkMode ? $af3a308a6aaf1dd3$var$rightColumnDarkStyles : $af3a308a6aaf1dd3$var$rightColumnLightStyles
        ]
    }, vector.component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $af3a308a6aaf1dd3$var$vectorComponentProps
    }, vector.component) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        role: "presentation",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            backgroundImage: `url(${isDarkMode ? vector?.dark : vector?.light})`
        },
        xcss: $af3a308a6aaf1dd3$var$rightVectorStyles
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $af3a308a6aaf1dd3$var$closeIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            spacing: "spacious",
            label: ""
        }),
        "aria-label": formatMessage((0, $585jx.messages).closeButtonNonFinal),
        onClick: onClose
    })));
};
const $af3a308a6aaf1dd3$var$contentContainerStyles = (0, $8CUq3.xcss)({
    height: '100%',
    position: 'relative'
});
const $af3a308a6aaf1dd3$var$vectorComponentProps = (0, $8CUq3.xcss)({
    flex: '1'
});
const $af3a308a6aaf1dd3$var$halfWidthStyles = (0, $8CUq3.xcss)({
    width: '50%',
    flexShrink: 0
});
const $af3a308a6aaf1dd3$var$contentStyles = (0, $8CUq3.xcss)({
    margin: 'space.600',
    padding: 'space.200'
});
const $af3a308a6aaf1dd3$var$actionStyles = (0, $8CUq3.xcss)({
    padding: 'space.200',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    borderLeft: 'none',
    borderRight: 'none',
    borderBottom: 'none'
});
const $af3a308a6aaf1dd3$var$locatorStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest'
});
const $af3a308a6aaf1dd3$var$rightColumnStyles = (0, $8CUq3.xcss)({
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderTopRightRadius: 'border.radius.100',
    borderBottomRightRadius: 'border.radius.100',
    overflow: 'hidden'
});
const $af3a308a6aaf1dd3$var$rightVectorStyles = (0, $8CUq3.xcss)({
    width: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $af3a308a6aaf1dd3$var$rightColumnLightStyles = (0, $8CUq3.xcss)({
    backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($jl2BD)))})`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $af3a308a6aaf1dd3$var$rightColumnDarkStyles = (0, $8CUq3.xcss)({
    backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($7X5Yl)))})`
});
const $af3a308a6aaf1dd3$var$closeIconStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    right: 'space.200',
    top: 'space.200'
});

});
parcelRegister("7X5Yl", function(module, exports) {
module.exports = new URL("right_section_bg_dark.dc17e2a1.svg", import.meta.url).toString();

});

parcelRegister("jl2BD", function(module, exports) {
module.exports = new URL("right_section_bg_light.524451d7.svg", import.meta.url).toString();

});

parcelRegister("585jx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $21ef1f3f04cb2411$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $21ef1f3f04cb2411$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    stepLocatorNonFinal: {
        "id": "eoc-changeboarding.common.wizard.layout.step-locator-non-final",
        "defaultMessage": "Step {currentStep} of 4"
    },
    nextButtonNonFinal: {
        "id": "eoc-changeboarding.common.wizard.layout.next-button-non-final",
        "defaultMessage": "Next"
    },
    backButtonNonFinal: {
        "id": "eoc-changeboarding.common.wizard.layout.back-button-non-final",
        "defaultMessage": "Back"
    },
    closeButtonNonFinal: {
        "id": "eoc-changeboarding.common.wizard.layout.close-button-non-final",
        "defaultMessage": "Close"
    },
    openShiftingGuideButtonNonFinal: {
        "id": "eoc-changeboarding.common.wizard.layout.open-shifting-guide-button-non-final",
        "defaultMessage": "Open guide"
    },
    remindMeLaterButtonNonFinal: {
        "id": "eoc-changeboarding.common.wizard.layout.remind-me-later-button-non-final",
        "defaultMessage": "Remind me later"
    }
});

});


parcelRegister("6FtII", function(module, exports) {

$parcel$export(module.exports, "Content", () => $4503e5cddec106db$export$7c6e2c02157bb7d2);

var $5uXOq = parcelRequire("5uXOq");

var $e3vlv = parcelRequire("e3vlv");

var $aS5mB = parcelRequire("aS5mB");

var $3vEdM = parcelRequire("3vEdM");
const $4503e5cddec106db$export$7c6e2c02157bb7d2 = ({ isFirstUnlocked: isFirstUnlocked, isAdmin: isAdmin })=>{
    if (isFirstUnlocked) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aS5mB.UnlockedAdminContent), null);
    if (isAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e3vlv.AdminContent), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3vEdM.UserContent), null);
};

});
parcelRegister("e3vlv", function(module, exports) {

$parcel$export(module.exports, "AdminContent", () => $605ab7d36fda55e0$export$55d2d5b64bfe8d2d);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $cwmS5 = parcelRequire("cwmS5");

var $34OIV = parcelRequire("34OIV");

var $8w53e = parcelRequire("8w53e");

var $fptva = parcelRequire("fptva");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $kXTK1 = parcelRequire("kXTK1");

var $k9ufy = parcelRequire("k9ufy");

var $czz1v = parcelRequire("czz1v");
const $605ab7d36fda55e0$export$55d2d5b64bfe8d2d = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ usersWithoutCustomRole: usersWithoutCustomRole, usersWithoutAdminRole: usersWithoutAdminRole }] = (0, $k9ufy.useUsersAndRolesStore)();
    if (usersWithoutCustomRole.data === null || usersWithoutAdminRole.data === null) // Users should not see this screen if one of the requests is still loading or error
    throw new Error('[Optimal StepFive Admin Content] should not be rendered if users are still loading');
    const usersWithoutCustomRoleCount = usersWithoutCustomRole.data.count;
    const usersWithoutAdminRoleCount = usersWithoutAdminRole.data.count;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        rowGap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xlarge"
    }, formatMessage((0, $czz1v.messages).titleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $czz1v.messages).descriptionNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $605ab7d36fda55e0$var$listTitleWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $czz1v.messages).listTitleNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8w53e))),
            appearance: "magenta",
            label: ""
        }),
        description: formatMessage((0, $czz1v.messages).configureChatIntegrationsNonFinal)
    }), usersWithoutAdminRoleCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($34OIV))),
            appearance: "purple",
            label: ""
        }),
        description: formatMessage((0, $czz1v.messages).giveProductAdminRoleNonFinal, {
            adminCount: usersWithoutAdminRoleCount
        })
    }), usersWithoutCustomRoleCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fptva))),
            appearance: "orange",
            label: ""
        }),
        description: formatMessage((0, $czz1v.messages).giveProductRoleNonFinal, {
            userCount: usersWithoutCustomRoleCount
        })
    })));
};
const $605ab7d36fda55e0$var$listTitleWrapperStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});
parcelRegister("cwmS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a921419639fe8f6f$export$2e2bcd8739ae039);
/* icon-tile.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
const $a921419639fe8f6f$var$sizeMap = {
    '16': "_1bsb7vkz _4t3i7vkz",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $a921419639fe8f6f$var$appearanceMap = {
    grayBold: "_bfhk1t1b _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhkc8cv _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkygwo _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhkjgng _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk1v33 _syaz16ni",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhkf2vu _syaz7r97",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk4v9p _syaz1ov1",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1jkz _syaz5yjc",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk3fv2 _syaz1oqg"
};
const $a921419639fe8f6f$var$shapeMap = {
    square: "_2rkoiti9",
    circle: "_2rko14q2"
};
const $a921419639fe8f6f$var$iconTileStyles = null;
function $a921419639fe8f6f$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent, testId: testId } = props;
    const ExpandedIcon = Icon;
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (LEGACY_fallbackComponent && !(0, $VSDnB.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $a921419639fe8f6f$var$appearanceMap[appearance],
            $a921419639fe8f6f$var$sizeMap[size],
            $a921419639fe8f6f$var$shapeMap[shape]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        })
    });
}

});

parcelRegister("kXTK1", function(module, exports) {

$parcel$export(module.exports, "WizardInfoItem", () => $36e52a72d183ce67$export$b32afacf54b9b55f);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");
const $36e52a72d183ce67$export$b32afacf54b9b55f = ({ iconTile: iconTile, title: title, description: description })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        columnGap: "space.100",
        alignItems: "start",
        xcss: $36e52a72d183ce67$var$containerStyles
    }, iconTile, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        rowGap: "space.025",
        direction: "column",
        xcss: $36e52a72d183ce67$var$contentWrapperStyles
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "xsmall"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, description)));
const $36e52a72d183ce67$var$containerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $36e52a72d183ce67$var$contentWrapperStyles = (0, $8CUq3.xcss)({
    alignSelf: 'center'
});

});

parcelRegister("czz1v", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6a84daa5ab021a46$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $6a84daa5ab021a46$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    titleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.admin.title-non-final",
        "defaultMessage": "Move your work from Opsgenie to Jira Service Management"
    },
    descriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.admin.description-non-final",
        "defaultMessage": "Almost all of your Opsgenie data and settings are now in Jira Service Management, so you no longer need Opsgenie to do your alerting and on-call work."
    },
    listTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.admin.list-title-non-final",
        "defaultMessage": "Let's go set up a few things so your team can get started"
    },
    configureChatIntegrationsNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.admin.configure-chat-integrations-non-final",
        "defaultMessage": "Configure chat integrations in Jira Service Management"
    },
    giveProductAdminRoleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.admin.give-product-admin-role-non-final",
        "defaultMessage": "Give the product admin role to {adminCount, plural, one {# Opsgenie admin} other {# Opsgenie admins}}"
    },
    giveProductRoleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.admin.give-product-role-non-final",
        "defaultMessage": "Give a product role to {userCount, plural, one {# Opsgenie user} other {# Opsgenie users}} who no longer have a custom role"
    }
});

});


parcelRegister("aS5mB", function(module, exports) {

$parcel$export(module.exports, "UnlockedAdminContent", () => $f6886b7af300ac7d$export$be18a8bc961d2bba);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $bUmQV = parcelRequire("bUmQV");
var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $g8zzh = parcelRequire("g8zzh");
const $f6886b7af300ac7d$export$be18a8bc961d2bba = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        rowGap: "space.200",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xlarge"
    }, formatMessage((0, $g8zzh.messages).titleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $g8zzh.messages).description1NonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $g8zzh.messages).description2NonFinal))));
};

});
parcelRegister("g8zzh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4f21a978cb9bea92$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4f21a978cb9bea92$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    titleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.first-unlocked-admin.title-non-final",
        "defaultMessage": "We're now moving you to Jira Service Management"
    },
    description1NonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.first-unlocked-admin.description-1-non-final",
        "defaultMessage": "Almost all of your Opsgenie data and settings are now in Jira Service Management."
    },
    description2NonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.first-unlocked-admin.description-2-non-final",
        "defaultMessage": "Let's go finish setting up some critical configurations, so your teams can start using operations in Jira Service Management."
    }
});

});


parcelRegister("3vEdM", function(module, exports) {

$parcel$export(module.exports, "UserContent", () => $bda13e9ad9e1420b$export$ef2ce2deea0ab0c1);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $cwmS5 = parcelRequire("cwmS5");

var $h9rhI = parcelRequire("h9rhI");

var $jDorM = parcelRequire("jDorM");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $kXTK1 = parcelRequire("kXTK1");

var $hgqTw = parcelRequire("hgqTw");
const $bda13e9ad9e1420b$export$ef2ce2deea0ab0c1 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        rowGap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xlarge"
    }, formatMessage((0, $hgqTw.messages).titleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $hgqTw.messages).descriptionNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $bda13e9ad9e1420b$var$listTitleWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $hgqTw.messages).listTitleNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jDorM))),
            appearance: "magenta",
            label: ""
        }),
        description: formatMessage((0, $hgqTw.messages).configureNotificationSettingsNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($h9rhI))),
            appearance: "purple",
            label: ""
        }),
        description: formatMessage((0, $hgqTw.messages).learnHowToWorkNonFinal)
    })));
};
const $bda13e9ad9e1420b$var$listTitleWrapperStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});
parcelRegister("h9rhI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83cc862a6ce0fb1f7d8883d625af8c63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7c8712306b53637$var$_react = $c7c8712306b53637$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7c8712306b53637$var$_baseNew = $c7c8712306b53637$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c7c8712306b53637$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7c8712306b53637$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $c7c8712306b53637$var$_react.default.createElement($c7c8712306b53637$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$c7c8712306b53637$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $c7c8712306b53637$var$_default = module.exports.default = $c7c8712306b53637$var$BookWithBookmarkIcon;

});

parcelRegister("hgqTw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f396ccaba1d3f1dd$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f396ccaba1d3f1dd$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    titleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.user.title-non-final",
        "defaultMessage": "Move your work from Opsgenie to Jira Service Management"
    },
    descriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.user.description-non-final",
        "defaultMessage": "Almost all of your Opsgenie data and settings are now in Jira Service Management, so you no longer need Opsgenie to do your alerting and on-call work."
    },
    listTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.user.list-title-non-final",
        "defaultMessage": "Let's go set up a few things so you can get started"
    },
    configureNotificationSettingsNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.user.configure-notification-settings-non-final",
        "defaultMessage": "Configure your notifications settings in Jira"
    },
    learnHowToWorkNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.five.content.user.learn-how-to-work-non-final",
        "defaultMessage": "Learn how operations works on Jira Service Management"
    }
});

});




parcelRegister("ab6K3", function(module, exports) {

$parcel$export(module.exports, "StepFour", () => $f7f00560076aee1c$export$b88edf692723a2ee);

var $5uXOq = parcelRequire("5uXOq");

var $7CMcV = parcelRequire("7CMcV");

var $k7m40 = parcelRequire("k7m40");

var $fVnbM = parcelRequire("fVnbM");
var $2rqOp = parcelRequire("2rqOp");

var $l1N8i = parcelRequire("l1N8i");

var $cwmS5 = parcelRequire("cwmS5");

var $h9rhI = parcelRequire("h9rhI");

var $8w53e = parcelRequire("8w53e");

var $9x5pH = parcelRequire("9x5pH");

var $9fIhE = parcelRequire("9fIhE");

var $c781K = parcelRequire("c781K");

var $e4yMr = parcelRequire("e4yMr");

var $bUmQV = parcelRequire("bUmQV");
var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $ieJ0b = parcelRequire("ieJ0b");

var $2YP9W = parcelRequire("2YP9W");

var $3353P = parcelRequire("3353P");

var $7dvx3 = parcelRequire("7dvx3");

var $kXTK1 = parcelRequire("kXTK1");

var $dL1CG = parcelRequire("dL1CG");

var $585jx = parcelRequire("585jx");

var $6BT89 = parcelRequire("6BT89");

var $k763U = parcelRequire("k763U");

var $bkDpW = parcelRequire("bkDpW");
const $f7f00560076aee1c$export$b88edf692723a2ee = ({ onAction: onAction, onClose: onClose, onUnlock: onUnlock })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: transitioningData } = (0, $2YP9W.useResource)((0, $ieJ0b.transitioningDetailsResource));
    const { timeZone: timeZone } = (0, $k763U.useUserTimezone)();
    const { activateWelcomeModal: activateWelcomeModal } = (0, $6BT89.useGlobalChangeboarding)();
    if (!transitioningData) throw new Error('[Optimal StepFour] component should not be rendered before details resource fetched');
    const [isUnlocking, setIsUnlocking] = (0, $5uXOq.useState)(false);
    const handleNext = ()=>{
        activateWelcomeModal();
        setIsUnlocking(true);
        onUnlock?.().then(()=>{
            onAction((prevState)=>prevState + 1);
        }).finally(()=>{
            setIsUnlocking(false);
        });
    };
    const primaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        onClick: handleNext,
        appearance: "primary",
        isLoading: isUnlocking
    }, formatMessage((0, $bkDpW.messages).primaryButtonTextNonFinal));
    const secondaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: ()=>onAction((prevState)=>prevState - 1),
        appearance: "default"
    }, formatMessage((0, $585jx.messages).backButtonNonFinal));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dL1CG.Layout), {
        vector: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($7dvx3))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($3353P)))
        },
        currentStep: 4,
        actionButtons: {
            primary: primaryActionButton,
            secondary: secondaryActionButton
        },
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        direction: "column",
        rowGap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        rowGap: "space.100",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "large"
    }, formatMessage((0, $bkDpW.messages).titleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $bkDpW.messages).descriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8w53e))),
            appearance: "magenta",
            label: ""
        }),
        description: formatMessage((0, $bkDpW.messages).firstItemNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($h9rhI))),
            appearance: "purple",
            label: ""
        }),
        description: formatMessage((0, $bkDpW.messages).secondItemNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9fIhE))),
            appearance: "teal",
            label: ""
        }),
        description: formatMessage((0, $bkDpW.messages).thirdItemNonFinal, {
            unlockDate: (0, $k7m40.default)((0, $7CMcV.default)(transitioningData?.autoOgTurnOffDate, timeZone), 'dd MMMM, yyyy')
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9x5pH))),
            appearance: "blue",
            label: ""
        }),
        description: formatMessage((0, $bkDpW.messages).fourthItemNonFinal, {
            link: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                    href: "https://support.atlassian.com/security-and-access-policies/docs/understand-data-residency/",
                    target: "_blank"
                }, str)
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($c781K))),
            appearance: "orange",
            label: ""
        }),
        description: formatMessage((0, $bkDpW.messages).fifthItemNonFinal)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $bkDpW.messages).dontReadyYetNonFinal, {
        link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
            href: "https://support.atlassian.com/jira-service-management-cloud/docs/start-shifting-from-opsgenie-to-jira-service-management/",
            target: "_blank"
        }, formatMessage((0, $bkDpW.messages).learnMoreNonFinal))
    }))));
};

});
parcelRegister("3353P", function(module, exports) {
module.exports = new URL("step_four_vector_dark.618d2aca.png", import.meta.url).toString();

});

parcelRegister("7dvx3", function(module, exports) {
module.exports = new URL("step_four_vector_light.e2c74d49.png", import.meta.url).toString();

});

parcelRegister("k763U", function(module, exports) {

$parcel$export(module.exports, "useUserTimezone", () => $61b09c1db2df12ec$export$a166f5a988ee846a);

var $cYlk7 = parcelRequire("cYlk7");
const $61b09c1db2df12ec$export$a166f5a988ee846a = ()=>{
    const { data: userData } = (0, $cYlk7.useCurrentUser)();
    const timeZone = 'timeZone' in userData.user ? userData.user.timeZone || 'UTC' : 'UTC';
    return {
        timeZone: timeZone
    };
};

});

parcelRegister("bkDpW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5965c2011d9fb0df$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5965c2011d9fb0df$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    titleNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.title-no-translate",
        "defaultMessage": "Ready to move from Opsgenie?"
    },
    descriptionNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.description-no-translate",
        "defaultMessage": "Here's a summary of what happens once you move:"
    },
    firstItemNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.first-item-no-translate",
        "defaultMessage": "Your Opsgenie data and settings will be copied to Jira Service Management, without any changes"
    },
    secondItemNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.second-item-no-translate",
        "defaultMessage": "You'll get a guide to finish setting up configurations that need your involvement"
    },
    thirdItemNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.third-item-no-translate",
        "defaultMessage": "Your Opsgenie site will continue to be accessible, until it's turned off on {unlockDate}"
    },
    fourthItemNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.fourth-item-no-translate",
        "defaultMessage": "Some of your data, including teams and team members, might change residency location from your selected server in Opsgenie. <link>Read more about data residency</link>"
    },
    fifthItemNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.fifth-item-no-translate",
        "defaultMessage": "Inform your organization admin about this change as after the move, your teams and team members will become visible across all sites within your Atlassian account."
    },
    learnMoreNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.learn-more-no-translate",
        "defaultMessage": "Read more about moving from Opsgenie"
    },
    dontReadyYetNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.dont-ready-yet-no-translate",
        "defaultMessage": "Don't feel ready yet? {link}"
    },
    primaryButtonTextNonFinal: {
        "id": "eoc-changeboarding.optimal.wizard.steps.four.primary-button-text-no-translate",
        "defaultMessage": "Let's start moving"
    }
});

});


parcelRegister("78zm0", function(module, exports) {

$parcel$export(module.exports, "StepOne", () => $85e934cdc0a13fc9$export$d644924ea55d67c0);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $cwmS5 = parcelRequire("cwmS5");

var $7Xp7u = parcelRequire("7Xp7u");

var $fNZB4 = parcelRequire("fNZB4");

var $jDorM = parcelRequire("jDorM");

var $fptva = parcelRequire("fptva");

var $epOG5 = parcelRequire("epOG5");

var $bUmQV = parcelRequire("bUmQV");
var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $3Sy4e = parcelRequire("3Sy4e");

var $6uObi = parcelRequire("6uObi");

var $kXTK1 = parcelRequire("kXTK1");

var $dL1CG = parcelRequire("dL1CG");

var $585jx = parcelRequire("585jx");

var $5DZDY = parcelRequire("5DZDY");
const $85e934cdc0a13fc9$export$d644924ea55d67c0 = ({ onAction: onAction, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const primaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: ()=>onAction((prevState)=>prevState + 1),
        appearance: "primary"
    }, formatMessage((0, $585jx.messages).nextButtonNonFinal));
    const secondaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onClose,
        appearance: "default"
    }, formatMessage((0, $585jx.messages).closeButtonNonFinal));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dL1CG.Layout), {
        vector: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($6uObi))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($3Sy4e)))
        },
        currentStep: 1,
        actionButtons: {
            primary: primaryActionButton,
            secondary: secondaryActionButton
        },
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        direction: "column",
        rowGap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        rowGap: "space.100",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "large"
    }, formatMessage((0, $5DZDY.messages).titleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $5DZDY.messages).descriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jDorM))),
            appearance: "orange",
            label: ""
        }),
        title: formatMessage((0, $5DZDY.messages).alertsTitleNonFinal),
        description: formatMessage((0, $5DZDY.messages).alertsDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($epOG5))),
            appearance: "lime",
            label: ""
        }),
        title: formatMessage((0, $5DZDY.messages).operationsTitleNonFinal),
        description: formatMessage((0, $5DZDY.messages).operationsDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Xp7u))),
            appearance: "teal",
            label: ""
        }),
        title: formatMessage((0, $5DZDY.messages).mobileTitleNonFinal),
        description: formatMessage((0, $5DZDY.messages).mobileDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fptva))),
            appearance: "blue",
            label: ""
        }),
        title: formatMessage((0, $5DZDY.messages).teamsTitleNonFinal),
        description: formatMessage((0, $5DZDY.messages).teamsDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fNZB4))),
            appearance: "purple",
            label: ""
        }),
        title: formatMessage((0, $5DZDY.messages).incidentsTitleNonFinal),
        description: formatMessage((0, $5DZDY.messages).incidentsDescriptionNonFinal)
    }))));
};

});
parcelRegister("7Xp7u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b629ce667363596df95f1c13e631244>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cb18762800f939e$var$_react = $5cb18762800f939e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5cb18762800f939e$var$_baseNew = $5cb18762800f939e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5cb18762800f939e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DeviceMobile".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: call, contact us.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cb18762800f939e$var$DeviceMobileIcon = (props)=>/*#__PURE__*/ $5cb18762800f939e$var$_react.default.createElement($5cb18762800f939e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2zm2-.5A.5.5 0 0 0 4 2v12a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5zM10 13H6v-1.5h4z" clip-rule="evenodd"/>`
    }, props));
$5cb18762800f939e$var$DeviceMobileIcon.displayName = 'DeviceMobileIcon';
var $5cb18762800f939e$var$_default = module.exports.default = $5cb18762800f939e$var$DeviceMobileIcon;

});

parcelRegister("fNZB4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cca747bf584e772ee6e9df3631122996>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b81b36817ee75239$var$_react = $b81b36817ee75239$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b81b36817ee75239$var$_baseNew = $b81b36817ee75239$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b81b36817ee75239$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b81b36817ee75239$var$IncidentIcon = (props)=>/*#__PURE__*/ $b81b36817ee75239$var$_react.default.createElement($b81b36817ee75239$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$b81b36817ee75239$var$IncidentIcon.displayName = 'IncidentIcon';
var $b81b36817ee75239$var$_default = module.exports.default = $b81b36817ee75239$var$IncidentIcon;

});

parcelRegister("3Sy4e", function(module, exports) {
module.exports = new URL("step_one_vector_dark.3cae4867.png", import.meta.url).toString();

});

parcelRegister("6uObi", function(module, exports) {
module.exports = new URL("step_one_vector_light.3d6a68ba.png", import.meta.url).toString();

});

parcelRegister("5DZDY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7563954c96425b2b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7563954c96425b2b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    titleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.title-non-final",
        "defaultMessage": "Move your work from Opsgenie to Jira Service Management"
    },
    descriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.description-non-final",
        "defaultMessage": "Make Jira Service Management your team's central place to do all the operations work that they do with Opsgenie."
    },
    alertsTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.alerts-title-non-final",
        "defaultMessage": "Respond to alerts"
    },
    alertsDescriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.alerts-description-non-final",
        "defaultMessage": "Access all your alerts natively from Jira Service Management's Your work page."
    },
    operationsTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.operations-title-non-final",
        "defaultMessage": "Manage operations"
    },
    operationsDescriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.operations-description-non-final",
        "defaultMessage": "Find your integrations, custom roles, maintenance, notifications, policies, audit logs, and more in Jira settings."
    },
    mobileTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.mobile-title-non-final",
        "defaultMessage": "Get mobile notifications"
    },
    mobileDescriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.mobile-description-non-final",
        "defaultMessage": "Stay notified of alerts, check on-call schedules, and manage notification rules on the go with Jira Cloud mobile."
    },
    teamsTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.teams-title-non-final",
        "defaultMessage": "Build efficient on-call teams"
    },
    teamsDescriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.teams-description-non-final",
        "defaultMessage": "Your Opsgenie teams will become Atlassian teams, so you can manage all your teams, including on-call, from Jira."
    },
    incidentsTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.incidents-title-non-final",
        "defaultMessage": "Streamlined incident management"
    },
    incidentsDescriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.one.incidents-description-non-final",
        "defaultMessage": "Detect and resolve incidents collaboratively in Jira Service Management."
    }
});

});


parcelRegister("6pFzR", function(module, exports) {

$parcel$export(module.exports, "StepThree", () => $0922918979750f7a$export$98c7d7d0f8104aa7);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $cwmS5 = parcelRequire("cwmS5");

var $hRf4g = parcelRequire("hRf4g");

var $50qBU = parcelRequire("50qBU");

var $7paD5 = parcelRequire("7paD5");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $jhmo0 = parcelRequire("jhmo0");

var $gDAJT = parcelRequire("gDAJT");

var $koVbs = parcelRequire("koVbs");

var $6FZUM = parcelRequire("6FZUM");

var $kXTK1 = parcelRequire("kXTK1");

var $dL1CG = parcelRequire("dL1CG");

var $585jx = parcelRequire("585jx");

var $lLiTq = parcelRequire("lLiTq");

var $5fIfP = parcelRequire("5fIfP");

var $4PWqB = parcelRequire("4PWqB");
const $0922918979750f7a$export$98c7d7d0f8104aa7 = ({ onAction: onAction, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const primaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: ()=>onAction((prevState)=>prevState + 1),
        appearance: "primary"
    }, formatMessage((0, $585jx.messages).nextButtonNonFinal));
    const secondaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: ()=>onAction((prevState)=>prevState - 1),
        appearance: "default"
    }, formatMessage((0, $585jx.messages).backButtonNonFinal));
    const [{ counts: integrationCounts }] = (0, $5fIfP.useIntegrationCounts)();
    const [{ hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats, heartbeats: heartbeats }] = (0, $lLiTq.useDeprecatedHeartbeats)();
    const [{ hasDeprecatedNotificationPolicies: hasDeprecatedNotificationPolicies, notificationPolicies: notificationPolicies }] = (0, $lLiTq.useDeprecatedNotificationPolicies)();
    const [{ hasDeprecatedGroups: hasDeprecatedGroups, groups: groups }] = (0, $lLiTq.useDeprecatedGroups)();
    const [{ hasDeprecatedIntegration: hasDeprecatedIntegration, deprecatedIntegrations: deprecatedIntegrations }] = (0, $5fIfP.useDeprecatedIntegrations)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dL1CG.Layout), {
        vector: {
            light: '',
            dark: '',
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gDAJT.default), {
                alt: "",
                width: 355
            })
        },
        currentStep: 3,
        actionButtons: {
            primary: primaryActionButton,
            secondary: secondaryActionButton
        },
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        rowGap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        rowGap: "space.100",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "large"
    }, formatMessage((0, $4PWqB.messages).titleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $4PWqB.messages).descriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, hasDeprecatedIntegration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))),
            appearance: "teal",
            label: ""
        }),
        title: formatMessage((0, $4PWqB.messages).integrationsInfoTitleNonFinal, {
            count: deprecatedIntegrations.data?.count
        }),
        description: formatMessage((0, $4PWqB.messages).integrationsInfoDescriptionNonFinal, {
            count: deprecatedIntegrations.data?.count,
            totalCount: integrationCounts.data?.totalCount
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($50qBU))),
            appearance: "purple",
            label: ""
        }),
        title: formatMessage((0, $4PWqB.messages).teamsApiInfoTitleNonFinal),
        description: formatMessage((0, $4PWqB.messages).teamsApiInfoDescriptionNonFinal)
    })), (hasDeprecatedGroups || hasDeprecatedGlobalHeartbeats || hasDeprecatedNotificationPolicies) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h3",
        size: "xsmall"
    }, formatMessage((0, $4PWqB.messages).moreConfigurationsNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        rowGap: "space.025",
        xcss: $0922918979750f7a$var$configurationItemsWrapperStyles
    }, hasDeprecatedGroups && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6FZUM.ConfigurationItem), null, formatMessage((0, $4PWqB.messages).groupNonFinal, {
        count: groups.data?.count
    })), hasDeprecatedGlobalHeartbeats && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6FZUM.ConfigurationItem), null, formatMessage((0, $4PWqB.messages).heartbeatsNonFinal, {
        count: heartbeats.data?.globalHeartbeatCount
    })), hasDeprecatedNotificationPolicies && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6FZUM.ConfigurationItem), null, formatMessage((0, $4PWqB.messages).notificationPoliciesNonFinal, {
        count: notificationPolicies.data?.count
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockStart: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/start-shifting-from-opsgenie-to-jira-service-management/#What-happens-after-starting-your-shift-from-Opsgenie",
        target: "_blank"
    }, formatMessage((0, $4PWqB.messages).learnMoreNonFinal), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
        label: "",
        LEGACY_size: "small"
    })))));
};
const $0922918979750f7a$var$configurationItemsWrapperStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});
parcelRegister("50qBU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f74f927ffa6330940d56635efcb4a7d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a519821f4edd432$var$_react = $3a519821f4edd432$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3a519821f4edd432$var$_baseNew = $3a519821f4edd432$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3a519821f4edd432$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Upload".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a519821f4edd432$var$UploadIcon = (props)=>/*#__PURE__*/ $3a519821f4edd432$var$_react.default.createElement($3a519821f4edd432$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.47 1.22a.75.75 0 0 1 1.06 0l4 4-1.06 1.06-2.72-2.72V11h-1.5V3.56L4.53 6.28 3.47 5.22zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$3a519821f4edd432$var$UploadIcon.displayName = 'UploadIcon';
var $3a519821f4edd432$var$_default = module.exports.default = $3a519821f4edd432$var$UploadIcon;

});

parcelRegister("gDAJT", function(module, exports) {

$parcel$export(module.exports, "default", () => $66f05628fd509e9f$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = hj7z88nh8g2n4vfpm6mv889q
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/hj7z88nh8g2n4vfpm6mv889q

var $dCLgq = parcelRequire("dCLgq");

var $5QSkk = parcelRequire("5QSkk");
const $66f05628fd509e9f$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5QSkk)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($5QSkk))
});
var $66f05628fd509e9f$export$2e2bcd8739ae039 = $66f05628fd509e9f$var$Illustration;
// for advanced use only
const $66f05628fd509e9f$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    235
];

});
parcelRegister("5QSkk", function(module, exports) {
module.exports = new URL("crystal-ball.30a0dd2d.svg", import.meta.url).toString();

});


parcelRegister("6FZUM", function(module, exports) {

$parcel$export(module.exports, "ConfigurationItem", () => $aa32db96444c9fcc$export$201f11292a316609);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");
const $aa32db96444c9fcc$export$201f11292a316609 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        columnGap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $aa32db96444c9fcc$var$markerWrapperStyles,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $aa32db96444c9fcc$var$markerStyles
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $aa32db96444c9fcc$var$textStyles,
        as: "span"
    }, children));
const $aa32db96444c9fcc$var$markerWrapperStyles = (0, $8CUq3.xcss)({
    width: 'size.100',
    height: 'size.100'
});
const $aa32db96444c9fcc$var$markerStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.gray.bolder',
    borderRadius: '100%',
    width: '7px',
    height: '7px'
});
const $aa32db96444c9fcc$var$textStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});

parcelRegister("4PWqB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b4e690297ebc4e4b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b4e690297ebc4e4b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    titleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.title-non-final",
        "defaultMessage": "What you'll leave behind in Opsgenie"
    },
    descriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.description-non-final",
        "defaultMessage": "A few legacy Opsgenie features that aren't supported by Jira Service Management will be left behind in Opsgenie. They'll keep working in Opsgenie until Opsgenie is turned off."
    },
    integrationsInfoTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.integrations-info-title-non-final",
        "defaultMessage": "{count, plural, one {{count} integration} other {{count} integrations}}"
    },
    integrationsInfoDescriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.integrations-info-description-non-final",
        "defaultMessage": "{count} of your {totalCount, plural, one {{totalCount} Opsgenie integration} other {{totalCount} Opsgenie integrations}} won't be available in Jira Service Management. They'll still work in Opsgenie."
    },
    teamsApiInfoTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.teams-api-info-title-non-final",
        "defaultMessage": "Teams API in Opsgenie"
    },
    teamsApiInfoDescriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.teams-api-info-description-non-final",
        "defaultMessage": "Opsgenie's API for team management won't work anymore. It will have to be done through the alternative Jira Cloud Platform API."
    },
    moreConfigurationsNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.more-configurations-non-final",
        "defaultMessage": "And a few more configurations:"
    },
    groupNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.group-non-final",
        "defaultMessage": "{count, plural, one {{count} group} other {{count} groups}}"
    },
    heartbeatsNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.heartbeats-non-final",
        "defaultMessage": "{count, plural, one {{count} global heartbeat} other {{count} global heartbeats}}"
    },
    notificationPoliciesNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.notification-policies-non-final",
        "defaultMessage": "{count, plural, one {{count} global notification policy} other {{count} global notification policies}}"
    },
    learnMoreNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.three.learn-more-non-final",
        "defaultMessage": "Read more about what you'll leave behind in Opsgenie"
    }
});

});


parcelRegister("1IRNJ", function(module, exports) {

$parcel$export(module.exports, "StepTwo", () => $29bbda40643646a4$export$f7c6032816713bb9);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $cwmS5 = parcelRequire("cwmS5");

var $bFmnZ = parcelRequire("bFmnZ");

var $fptva = parcelRequire("fptva");

var $e4yMr = parcelRequire("e4yMr");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $2TCYq = parcelRequire("2TCYq");

var $hvumO = parcelRequire("hvumO");

var $6FZUM = parcelRequire("6FZUM");

var $kXTK1 = parcelRequire("kXTK1");

var $dL1CG = parcelRequire("dL1CG");

var $585jx = parcelRequire("585jx");

var $5fIfP = parcelRequire("5fIfP");

var $k9ufy = parcelRequire("k9ufy");

var $fJDtE = parcelRequire("fJDtE");
const $29bbda40643646a4$export$f7c6032816713bb9 = ({ onAction: onAction, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ usersWithoutCustomRole: usersWithoutCustomRole, usersWithoutAdminRole: usersWithoutAdminRole }] = (0, $k9ufy.useUsersAndRolesStore)();
    if (usersWithoutCustomRole.data === null || usersWithoutAdminRole.data === null) // Users should not see this screen if one of the requests is still loading or error
    throw new Error('[Optimal StepTwo] should not be rendered if users are still loading');
    const usersWithoutCustomRoleCount = usersWithoutCustomRole.data.count;
    const usersWithoutAdminRoleCount = usersWithoutAdminRole.data.count;
    const [{ counts: integrationCounts }] = (0, $5fIfP.useIntegrationCounts)();
    const chatCount = integrationCounts.data?.chatCount || 0;
    const primaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: ()=>onAction((prevState)=>prevState + 1),
        appearance: "primary"
    }, formatMessage((0, $585jx.messages).nextButtonNonFinal));
    const secondaryActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: ()=>onAction((prevState)=>prevState - 1),
        appearance: "default"
    }, formatMessage((0, $585jx.messages).backButtonNonFinal));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dL1CG.Layout), {
        vector: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($hvumO))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($2TCYq)))
        },
        currentStep: 2,
        actionButtons: {
            primary: primaryActionButton,
            secondary: secondaryActionButton
        },
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        rowGap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        rowGap: "space.100",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "large"
    }, formatMessage((0, $fJDtE.messages).titleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $fJDtE.messages).descriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, (usersWithoutCustomRoleCount > 0 || usersWithoutAdminRoleCount > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fptva))),
            appearance: "teal",
            label: ""
        }),
        title: formatMessage((0, $fJDtE.messages).usersRoleTitleNonFinal),
        description: formatMessage((0, $fJDtE.messages).usersRoleDescriptionNonFinal, {
            adminCount: usersWithoutAdminRoleCount,
            userCount: usersWithoutCustomRoleCount
        })
    }), chatCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kXTK1.WizardInfoItem), {
        iconTile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bFmnZ))),
            appearance: "lime",
            label: ""
        }),
        title: formatMessage((0, $fJDtE.messages).chatIntegrationsTitleNonFinal),
        description: formatMessage((0, $fJDtE.messages).chatIntegrationsDescriptionNonFinal, {
            chatCount: chatCount
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall",
        as: "h2"
    }, formatMessage((0, $fJDtE.messages).configurationsTitleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        rowGap: "space.025",
        xcss: $29bbda40643646a4$var$configurationItemsWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6FZUM.ConfigurationItem), null, formatMessage((0, $fJDtE.messages).actionsAndIncidentRulesNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6FZUM.ConfigurationItem), null, formatMessage((0, $fJDtE.messages).heartbeatsNonFinal)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/start-shifting-from-opsgenie-to-jira-service-management",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $fJDtE.messages).readMoreAboutNonFinal)))));
};
const $29bbda40643646a4$var$configurationItemsWrapperStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});
parcelRegister("bFmnZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87e4e36d6c115ce9$var$_react = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87e4e36d6c115ce9$var$_baseNew = $87e4e36d6c115ce9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $87e4e36d6c115ce9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87e4e36d6c115ce9$var$CommentIcon = (props)=>/*#__PURE__*/ $87e4e36d6c115ce9$var$_react.default.createElement($87e4e36d6c115ce9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$87e4e36d6c115ce9$var$CommentIcon.displayName = 'CommentIcon';
var $87e4e36d6c115ce9$var$_default = module.exports.default = $87e4e36d6c115ce9$var$CommentIcon;

});

parcelRegister("2TCYq", function(module, exports) {
module.exports = new URL("step_two_vector_dark_optimal.f8537d1f.png", import.meta.url).toString();

});

parcelRegister("hvumO", function(module, exports) {
module.exports = new URL("step_two_vector_light_optimal.f3cf8e53.png", import.meta.url).toString();

});

parcelRegister("fJDtE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d31a72ac957be233$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d31a72ac957be233$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    titleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.title-non-final",
        "defaultMessage": "What you'll need to set up"
    },
    descriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.description-non-final",
        "defaultMessage": "Almost all of your Opsgenie settings will be synced with Jira Service Management, only some configurations will need your involvement."
    },
    usersRoleTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.users-role-title-non-final",
        "defaultMessage": "Verify users' roles"
    },
    usersRoleDescriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.users-role-description-non-final",
        "defaultMessage": "{adminCount, plural,\n            =0 {{userCount, plural, =0 {} one {{userCount} Opsgenie user} other {{userCount} Opsgenie users}}}\n             one {{userCount, plural, =0 {{adminCount} Opsgenie admin} one {{adminCount} Opsgenie admin and {userCount} user} other {{adminCount} Opsgenie admin and {userCount} users}}}\n            other {{userCount, plural, =0 {{adminCount} Opsgenie admins} one {{adminCount} Opsgenie admins and {userCount} user} other {{adminCount} Opsgenie admins and {userCount} users}}}\n        } who don't have the same role in Jira Service Management."
    },
    chatIntegrationsTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.chat-integrations-title-non-final",
        "defaultMessage": "Copy chat integrations"
    },
    chatIntegrationsDescriptionNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.chat-integrations-description-non-final",
        "defaultMessage": "Connect your chat tools and copy your {chatCount, plural, one {# Opsgenie chat integration} other {# Opsgenie chat integrations}} to Jira Service Management."
    },
    configurationsTitleNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.configurations-title-non-final",
        "defaultMessage": "And a few more configurations:"
    },
    actionsAndIncidentRulesNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.actions-and-incident-rules-non-final",
        "defaultMessage": "Actions and incident rules"
    },
    heartbeatsNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.heartbeats-non-final",
        "defaultMessage": "Heartbeats"
    },
    readMoreAboutNonFinal: {
        "id": "eoc-changeboarding.wizard.optimal.steps.two.read-more-about-non-final",
        "defaultMessage": "Read more about setting up operations"
    }
});

});





//# sourceMappingURL=async-eoc-changeboarding-layout-welcome-modal-renderer.6bd49d03.js.map
